export const staticMondayConfig = {
    data: {
        boards: [
            {
                items_page: {
                    items: [
                        {
                            name: "Workcanvas new shapes",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-04-10T11:08:02.296Z","linkedPulseIds":[{"linkedPulseId":6242169120}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-04-10T11:08:08.812Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-04-10T11:08:13.596Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2024-04-10T11:14:39.778Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"New shapes on your WorkCanvas"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Enjoy an extended variety of new shapes on your WorkCanvas, ensuring the Canvas visuals of your dreams.","changed_at":"2024-04-10T11:13:39.786Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/13384193666194-Build-your-WorkCanvas","text":"https://support.monday.com/hc/en-us/articles/13384193666194-Build-your-WorkCanvas"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-04-10T11:08:13.923Z","linkedPulseIds":[{"linkedPulseId":6426829006}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "AI summarize and improve text block",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:31:42.058Z","linkedPulseIds":[{"linkedPulseId":6348062748},{"linkedPulseId":6348062833}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-04-08T11:39:49.276Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:31:02.892Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[]}'
                                }
                            ]
                        },
                        {
                            name: "AI custom block",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-04-08T11:34:33.014Z","linkedPulseIds":[{"linkedPulseId":6348065004}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-04-08T11:39:43.073Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:31:02.892Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Pipeline widget",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-04-08T12:06:50.235Z","linkedPulseIds":[{"linkedPulseId":6228009413}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:30:47.217Z","personsAndTeams":[{"id":28252415,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:31:02.892Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Custom fiscal year start",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-04-08T11:24:19.492Z","linkedPulseIds":[{"linkedPulseId":6275225021}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-04-08T11:39:56.777Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:31:02.892Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Pin timetime items",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:10:50.027Z","linkedPulseIds":[{"linkedPulseId":6228010571}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:30:53.175Z","personsAndTeams":[{"id":28252415,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-04-09T09:31:02.892Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Automations Connection Management Page (board and admin-level)",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-03-07T12:26:28.502Z","linkedPulseIds":[{"linkedPulseId":5764916495},{"linkedPulseId":4896083440}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:53.047Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:42:55.603Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-04-08T07:28:07.272Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Integrations connection management"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now manage all of your monday.com Integration connections in one place!","changed_at":"2024-04-01T08:13:41.512Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-03-30","changed_at":"2024-04-04T08:29:45.614Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,163,162]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-27T14:15:25.059Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-27T14:15:17.918Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-27T14:15:16.077Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2024-03-27T14:15:13.988Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/17366794776978-monday-com-Integrations-management","text":"monday.com Integrations connection management"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1712561136/Generator_featured%20images/Whats%20new%20page/items%20images/Automations_Connection_Management_Page_board_and_admin-level.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1712561136/Generator_featured%20images/Whats%20new%20page/items%20images/Automations_Connection_Management_Page_board_and_admin-level.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Burndown filters",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-03-07T12:22:44.310Z","linkedPulseIds":[{"linkedPulseId":5764201483}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:03.142Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:42:55.603Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-04-03T06:56:51.141Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Burndown chart filters"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Filter your monday dev burndown chart by a People or Status Column to better understand your team\'s trends and improve velocity.","changed_at":"2024-03-18T08:21:58.747Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-03-28","changed_at":"2024-03-31T09:14:13.387Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2024-04-08T07:19:08.178Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,160,4,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-18T08:23:57.854Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-18T08:24:07.088Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-18T08:24:15.750Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/17003133339410-The-Burndown-Chart","text":"The Burndown Chart"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1712127221/Generator_featured%20images/Whats%20new%20page/items%20images/Burndown_filters.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1712127221/Generator_featured%20images/Whats%20new%20page/items%20images/Burndown_filters.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Track email link clicks",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-03-07T12:23:08.927Z","linkedPulseIds":[{"linkedPulseId":6185799909}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:08.324Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:42:55.603Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-04-04T08:29:24.817Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Track link click through rates"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve added the ability to track click through rates in your mass emails! This gives you more ways to measure engagement with your email campaigns.","changed_at":"2024-03-27T14:00:50.530Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-03-21","changed_at":"2024-04-04T08:29:17.031Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,160,4,159,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-03-27T14:01:53.205Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-27T14:01:13.610Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-27T14:01:17.750Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-03-27T14:01:45.461Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/12428852177810-Emails-activities-how-it-works#h_01HGGBC0E4FMP7YS7PDNYRE6TE","text":"Emails & activities: how it works"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1712133409/Generator_featured%20images/Whats%20new%20page/items%20images/email_link_tracking.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1712133409/Generator_featured%20images/Whats%20new%20page/items%20images/email_link_tracking.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "workcanvas synced templates (to monday)",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-03-07T12:24:00.385Z","linkedPulseIds":[{"linkedPulseId":6184376728}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:13.417Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:42:55.603Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-25T09:42:12.149Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"WorkCanvas synced templates"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"WorkCanvas premade synced templates will automatically create a board on your monday.com account with a logical connection to your canvas. Ensuring an easy and intuitive workflow.","changed_at":"2024-03-13T12:41:09.176Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-03-13","changed_at":"2024-03-25T09:41:59.523Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2024-03-07T12:47:27.523Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[5]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,164,158,163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-25T09:40:47.830Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-25T09:40:45.542Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-25T09:40:26.639Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/16760164756242-Integrate-WorkCanvas-with-your-monday-boards#workcanvas_synced_templates","text":"Integrate WorkCanvas with your monday boards"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1711359573/Generator_featured%20images/Whats%20new%20page/items%20images/workcanvas_synced_templates_to_monday.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1711359573/Generator_featured%20images/Whats%20new%20page/items%20images/workcanvas_synced_templates_to_monday.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:16.585Z","linkedPulseIds":[{"linkedPulseId":6228038917}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Burndown chart breakdown",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-03-07T12:22:57.980Z","linkedPulseIds":[{"linkedPulseId":6006485627}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:03.142Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:42:55.603Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-27T09:22:39.082Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Burndown chart breakdown"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Apply a breakdown filter to your burndown chart to view your data organized by the labels in your Status Column","changed_at":"2024-03-18T08:28:03.495Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-03-18","changed_at":"2024-03-27T09:22:29.295Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,160,4,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-27T09:21:30.197Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-18T08:25:09.595Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-18T08:25:07.943Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/17003133339410-The-Burndown-Chart","text":"The Burndown Chart"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1711531256/Generator_featured%20images/Whats%20new%20page/items%20images/Burndown_chart_breakdown.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1711531256/Generator_featured%20images/Whats%20new%20page/items%20images/Burndown_chart_breakdown.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Reply from email",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-03-07T12:24:20.311Z","linkedPulseIds":[{"linkedPulseId":3996008692}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:48.105Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:42:55.603Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-18T08:18:25.010Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Reply directly in email"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"To simplify the work process, you can reply to updates from within your email, without having to go to the updates section in monday.com","changed_at":"2024-03-18T08:16:39.824Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-03-04","changed_at":"2024-03-18T08:16:44.079Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-18T08:17:38.114Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-18T08:17:44.319Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-18T08:17:49.381Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005319529-Email-notifications","text":"https://support.monday.com/hc/en-us/articles/115005319529-Email-notifications"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1710749585/Generator_featured%20images/Whats%20new%20page/items%20images/Reply_from_email.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1710749585/Generator_featured%20images/Whats%20new%20page/items%20images/Reply_from_email.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-03-10T10:43:50.935Z","linkedPulseIds":[{"linkedPulseId":6228039361}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkCanvas - org chart 2.0",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:16:12.665Z","linkedPulseIds":[{"linkedPulseId":5627445113}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:33:07.841Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:16:24.156Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-01T09:50:27.093Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"The WorkCanvas Org Chart template"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Illustrate the structure of your organization with its various teams, reporting structures, and profiles of all employees, using the WorkCanvas Org Chart template.","changed_at":"2024-02-15T10:43:57.840Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-22","changed_at":"2024-03-01T09:50:16.566Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[5]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-01T09:49:56.153Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-01T09:49:53.702Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-01T09:49:49.017Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/17002448073106-WorkCanvas-Org-Chart-template","text":"WorkCanvas Org Chart template"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1709286568/Generator_featured%20images/Whats%20new%20page/items%20images/WorkCanvas_-_org_chart_2.0.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1709286568/Generator_featured%20images/Whats%20new%20page/items%20images/WorkCanvas_-_org_chart_2.0.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:36.680Z","linkedPulseIds":[{"linkedPulseId":6027527303}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "State Machine (Mandatory fields on status change)",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:17:57.988Z","linkedPulseIds":[{"linkedPulseId":5508123909}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:33:15.896Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-15T15:23:13.422Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Conditional status changes"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"With our latest addition to monday CRM for Enterprise, you can set conditions for status changes. Requiring key details before allowing a status change means that important details will never be left out of a deal again!","changed_at":"2024-02-16T15:49:45.070Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-05","changed_at":"2024-02-15T15:20:58.218Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-15T15:22:49.524Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2024-02-15T15:22:58.234Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-15T15:14:53.200Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2024-02-15T14:56:04.853Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/16157142497810-Conditional-status-changes","text":"Conditional status changes"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708010435/Generator_featured%20images/Whats%20new%20page/items%20images/State_Machine_Mandatory_fields_on_status_change.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708010435/Generator_featured%20images/Whats%20new%20page/items%20images/State_Machine_Mandatory_fields_on_status_change.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Mobile app new design 🎉",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:21:19.681Z","linkedPulseIds":[{"linkedPulseId":5257418559}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:33:24.419Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-15T13:09:33.183Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Mobile app redesign"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"The mobile app now has a fresh new look! Head over to your app to check out our sleek brand-new design.","changed_at":"2024-02-15T11:19:00.928Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-02","changed_at":"2024-02-15T12:00:33.412Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-15T12:01:12.391Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-15T12:01:14.759Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-15T12:01:16.994Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708005302/Generator_featured%20images/Whats%20new%20page/items%20images/Mobile_has_just_got_a_makeover_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708005302/Generator_featured%20images/Whats%20new%20page/items%20images/Mobile_has_just_got_a_makeover_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Mention doc",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:23:03.054Z","linkedPulseIds":[{"linkedPulseId":5619941592}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:33:31.673Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-28T14:18:13.069Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Mention a Doc"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Seamlessly add another Doc inline with your text that will open up in a separate browser tab. Simply type \\"/doc\\", click \\"mention doc\\" and select a doc from the list to link it to your Doc.","changed_at":"2024-02-28T14:18:11.299Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-16","changed_at":"2024-02-28T14:15:46.957Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-28T14:15:23.813Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-28T14:15:21.714Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-28T14:15:19.981Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8564146615698-monday-workdoc-text-and-elements","text":"monday workdoc text and elements"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1709129659/Generator_featured%20images/Whats%20new%20page/items%20images/Mention_Doc.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1709129659/Generator_featured%20images/Whats%20new%20page/items%20images/Mention_Doc.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Image caption",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:25:21.455Z","linkedPulseIds":[{"linkedPulseId":5997374349}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:33:31.673Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-11T09:51:31.035Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Captions on Doc images"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Add a fully customizable caption to images in your Doc. You can change the alignment, write in bold or italics, and hide it from sight with the click of a button.","changed_at":"2024-02-28T14:02:02.669Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-20","changed_at":"2024-03-11T09:50:47.650Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-11T09:51:13.671Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-11T09:51:17.378Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-11T09:51:22.564Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8564146615698-monday-workdoc-text-and-elements","text":"monday workdoc text and elements"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1710150606/Generator_featured%20images/Whats%20new%20page/items%20images/Image_caption.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1710150606/Generator_featured%20images/Whats%20new%20page/items%20images/Image_caption.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Custom table size option",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:25:30.180Z","linkedPulseIds":[{"linkedPulseId":5997393273}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:33:31.673Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-11T10:09:24.716Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Custom Doc tables and layouts"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Now it\'s easier than ever to create a table or layout in your Doc. Instead of choosing from an existing design, create your own custom table by typing \\"/\\" followed by \\"table\\" or \\"layout\\" and using your cursor to highlight the cells that you want it to contain.","changed_at":"2024-03-13T20:45:02.298Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-28","changed_at":"2024-03-11T10:08:24.121Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-03-11T10:05:40.380Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-03-11T10:05:34.809Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-03-11T10:05:31.946Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8564146615698-monday-workdoc-text-and-elements","text":"monday workdoc text and elements"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1710151462/Generator_featured%20images/Whats%20new%20page/items%20images/Table_picker.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1710151462/Generator_featured%20images/Whats%20new%20page/items%20images/Table_picker.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Unified automations and integrations center",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:28:07.056Z","linkedPulseIds":[{"linkedPulseId":5710937227}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:43.444Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-28T14:13:50.048Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"The new Automation center"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We now host Automations and Integrations in one unified Automation center. Find everything you need in one place!","changed_at":"2024-02-26T18:06:36.444Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-13","changed_at":"2024-02-28T14:13:37.726Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,162,164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-26T18:07:42.700Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-26T18:07:45.776Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-26T18:07:50.183Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/15080944734482-The-new-Automation-Center","text":"The new Automation Center"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708850755/Generator_featured%20images/Whats%20new%20page/items%20images/Unified_automations_and_integrations_center.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708850755/Generator_featured%20images/Whats%20new%20page/items%20images/Unified_automations_and_integrations_center.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "When sub item is created automation trigger",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:29:56.920Z","linkedPulseIds":[{"linkedPulseId":5994128378}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:43.444Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-02-08T14:32:20.321Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-15T15:23:57.067Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"New subitem automation trigger"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You now have the option to trigger an automation every time a subitem is created!","changed_at":"2024-02-15T15:13:04.655Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-02-06","changed_at":"2024-02-15T15:24:06.729Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-02-15T15:22:44.051Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-15T15:18:21.157Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-15T15:15:01.093Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2024-02-15T15:21:54.374Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360017311219-Subitems-and-automations#01GQY58AXKWWD8BZAABNY6RATQ","text":"Subitems and automations"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708241618/Generator_featured%20images/Whats%20new%20page/items%20images/When_sub_item_is_created_automation_trigger_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1708241618/Generator_featured%20images/Whats%20new%20page/items%20images/When_sub_item_is_created_automation_trigger_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "workcanvas is out of beta",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-07T15:03:23.657Z","linkedPulseIds":[{"linkedPulseId":5561434129}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:40.140Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-01T12:52:48.798Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Introducing WorkCanvas"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"WorkCanvas is a collaborative digital whiteboard that connects directly to monday.com and allows teams to visually brainstorm, map out, and work together on anything!","changed_at":"2024-02-01T12:52:40.925Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-31","changed_at":"2024-02-01T12:48:26.442Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-18T14:18:13.198Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[5]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,164,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-01T12:49:08.209Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-01T12:49:11.432Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-01T12:49:13.295Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/13206630995346","text":"Get started with WorkCanvas"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1706791895/Generator_featured%20images/Whats%20new%20page/items%20images/workcanvas_is_out_of_beta_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1706791820/Generator_featured%20images/Whats%20new%20page/items%20images/workcanvas_is_out_of_beta_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:46.304Z","linkedPulseIds":[{"linkedPulseId":5779126226}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "My work - Add tasks to my assigned items",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-03T11:23:43.264Z","linkedPulseIds":[{"linkedPulseId":4896600609}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:56:40.737Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-10T13:10:36.937Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Adding items from within My Work"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"For efficiency and ease when managing your daily work, you can now add items directly from your My Work page.","changed_at":"2024-01-10T13:08:39.115Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-03","changed_at":"2024-01-10T13:08:40.635Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-01-10T13:09:33.844Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-01-10T13:09:36.040Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-01-10T13:09:37.940Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/9516773224466","text":"My work - new layout"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1704892221/Generator_featured%20images/Whats%20new%20page/items%20images/My_work_-_Add_tasks_to_my_assigned_items.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1704892221/Generator_featured%20images/Whats%20new%20page/items%20images/My_work_-_Add_tasks_to_my_assigned_items.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:56:44.300Z","linkedPulseIds":[{"linkedPulseId":5779135083}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Workload- new & improved person filter",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-03T11:24:23.167Z","linkedPulseIds":[{"linkedPulseId":5097181492}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:56:07.372Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-16T15:08:33.689Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved person filter for the Workload widget"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve upgraded the person filter on the Workload widget to make it easier to view specific teams or certain individual\'s workload data.","changed_at":"2024-01-16T15:08:00.673Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-08","changed_at":"2024-01-16T15:08:06.789Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-01-16T15:08:20.250Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-01-16T15:08:22.758Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-01-16T15:08:28.284Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010699760#Drill_down","text":"https://support.monday.com/hc/en-us/articles/360010699760#Drill_down"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1705587621/Generator_featured%20images/Whats%20new%20page/items%20images/Workload-_new_improved_person_filter.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1705587621/Generator_featured%20images/Whats%20new%20page/items%20images/Workload-_new_improved_person_filter.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:56:10.804Z","linkedPulseIds":[{"linkedPulseId":5779132055}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Permission to create open/closed workspaces",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-03T11:24:12.048Z","linkedPulseIds":[{"linkedPulseId":5764620858}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:15.622Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-22T13:12:44.426Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"New permission: Create open/closed workspaces"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"As part of the Enterprise account permissions, admins can now enable or disable the creation of open or closed workspaces for other team members.","changed_at":"2024-01-22T13:11:42.839Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-15","changed_at":"2024-01-22T13:02:29.308Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-07T10:00:58.003Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2024-01-22T13:03:02.139Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-07T10:01:00.051Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003457320","text":"Account permissions"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1705929147/Generator_featured%20images/Whats%20new%20page/items%20images/closed_workspaces.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1705929147/Generator_featured%20images/Whats%20new%20page/items%20images/closed_workspaces.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Crunchbase company enrichment",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-03T11:24:29.605Z","linkedPulseIds":[{"linkedPulseId":5068476884}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:21.621Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-31T15:59:22.193Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Get the full picture with auto-enriched company data"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Automatically access best-in-class company information, like industry and employee size, on every account with data from Crunchbase so you can quickly target the right companies and inform outreach.","changed_at":"2024-02-07T12:04:53.248Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-19","changed_at":"2024-01-31T15:59:18.719Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,4,160]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-23T15:58:56.921Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2024-01-23T15:56:18.147Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-01-23T15:58:37.239Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/15541177212818-CRM-Data-enrichment-app","text":"CRM Data enrichment app"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1706716718/Generator_featured%20images/Whats%20new%20page/items%20images/Crunchbase_company_enrichment.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1706716718/Generator_featured%20images/Whats%20new%20page/items%20images/Crunchbase_company_enrichment.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms - Single and multi select questions upgraded",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:16.459Z","linkedPulseIds":[{"linkedPulseId":5660490451},{"linkedPulseId":5661601546}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:28.699Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-07T10:01:22.777Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved WorkForms single and multi select question"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Easily reorder the options in your single or multi select questions on WorkForms, by dragging and dropping them.","changed_at":"2024-02-07T10:00:24.771Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-30","changed_at":"2024-02-07T10:00:29.111Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-02-07T10:00:41.690Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-07T10:00:43.978Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-07T10:00:52.282Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/14124262264978#choose_your_question_type","text":"Build out your WorkForm"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1707299983/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_-_Single_and_multi_select_questions_upgraded.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1707299983/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_-_Single_and_multi_select_questions_upgraded.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:33.023Z","linkedPulseIds":[{"linkedPulseId":5779123908}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms - People and connected boards questions in public forms",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2024-01-03T11:24:44.112Z","linkedPulseIds":[{"linkedPulseId":5661623501}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:28.699Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:57:32.914Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-01T13:02:10.091Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Use the People Column question in public WorkForms"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"With a quick change in your admin settings, the People Column question can now be made available in public forms!","changed_at":"2024-01-03T13:10:02.003Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2024-01-24","changed_at":"2024-02-01T13:01:15.807Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2024-02-01T13:01:32.248Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-02-01T13:01:35.090Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-01T13:01:36.954Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11040473466258#account_level_permissions","text":"https://support.monday.com/hc/en-us/articles/11040473466258#account_level_permissions"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1706792463/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_-_People_and_connected_boards_questions_in_public_forms.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1706792463/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_-_People_and_connected_boards_questions_in_public_forms.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2024-01-03T12:54:33.443Z","linkedPulseIds":[{"linkedPulseId":5779123938}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "MDB Multi-board Dashboards",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:01:27.603Z","linkedPulseIds":[{"linkedPulseId":4106372256}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:01:29.984Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:05:05.909Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-14T13:24:26.642Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved dashboard performance with mondayDB"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Your largest dashboards will now load in a matter of seconds and will run much smoother thanks to our new data engine mondayDB.","changed_at":"2023-12-14T13:22:43.694Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-07","changed_at":"2023-12-14T13:22:50.605Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-02-01T13:02:43.689Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-12-14T13:23:16.082Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-01T13:02:45.238Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11407684117266","text":"Introducing mondayDB"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1702560238/Generator_featured%20images/Whats%20new%20page/items%20images/MDB_Multi-board_Dashboards.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1702560238/Generator_featured%20images/Whats%20new%20page/items%20images/MDB_Multi-board_Dashboards.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Homepage keyboard accessibility",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-03T19:58:26.377Z","linkedPulseIds":[{"linkedPulseId":5570840189}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-03T19:58:45.212Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-04T13:26:37.481Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-25T14:40:25.098Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Keyboard navigation for the homepage"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"The monday.com homepage was made accessible for keyboard navigation, eliminating the need to use a mouse to locate the information you need.","changed_at":"2023-12-25T14:38:08.540Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-13","changed_at":"2023-12-25T14:38:15.869Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[166]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-25T14:38:35.789Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-12-25T14:38:38.679Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-12-25T14:38:40.437Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000571925-Accessibility","text":"Accessibility"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1703515192/Generator_featured%20images/Whats%20new%20page/items%20images/Homepage_keyboard_accessibility_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1703515192/Generator_featured%20images/Whats%20new%20page/items%20images/Homepage_keyboard_accessibility_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Administration keyboard navigation",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-03T19:58:38.117Z","linkedPulseIds":[{"linkedPulseId":5570860460}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-03T19:58:45.212Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-04T13:26:37.481Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-02T09:18:09.391Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Administration page accessibility improvements"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve enabled keyboard navigation on the administration page so that you can move around the page without needing to use a mouse.","changed_at":"2024-01-02T09:17:46.913Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-22","changed_at":"2024-01-02T09:15:28.850Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[166]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-02T09:15:00.115Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-01-02T09:14:57.265Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-01-02T09:14:55.113Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000571925-Accessibility","text":"Accessibility"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1704186781/Generator_featured%20images/Whats%20new%20page/items%20images/Administration_keyboard_navigation.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1704186781/Generator_featured%20images/Whats%20new%20page/items%20images/Administration_keyboard_navigation.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "GitHub - support for monday -> Github flows",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:01:40.504Z","linkedPulseIds":[{"linkedPulseId":4243447606}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:04:45.100Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:05:05.909Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-27T08:53:00.529Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"monday to GitHub integration flow"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We now support monday to GitHub flows using our GitHub integration, also allowing the option for a two-way connection.","changed_at":"2023-12-27T08:50:53.439Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-19","changed_at":"2023-12-27T08:51:16.832Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-27T08:52:15.530Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-12-27T08:52:19.122Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-12-27T08:52:21.510Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/4413247738770#create_a_two-way_sync","text":"The New GitHub Integration"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1703666931/Generator_featured%20images/Whats%20new%20page/items%20images/GitHub_-_support_for_monday_-__Github_flows.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1703666931/Generator_featured%20images/Whats%20new%20page/items%20images/GitHub_-_support_for_monday_-__Github_flows.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Support for gitHub recipes on sub-items",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:02:00.388Z","linkedPulseIds":[{"linkedPulseId":5017780726}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:04:19.187Z","personsAndTeams":[{"id":13267772,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:05:05.909Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-27T15:30:35.412Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Subitems on GitHub Integration"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve added the capability to select subitem columns when mapping out your GitHub integration recipes, allowing you to take your workflows up to the next level.","changed_at":"2023-12-27T15:28:49.086Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-21","changed_at":"2023-12-27T15:28:51.393Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-12-27T15:29:01.055Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-12-27T15:29:03.175Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-12-27T15:29:05.792Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/4413247738770#","text":"The New GitHub Integration"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1703689054/Generator_featured%20images/Whats%20new%20page/items%20images/Support_for_gitHub_recipes_on_sub-items.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1703689054/Generator_featured%20images/Whats%20new%20page/items%20images/Support_for_gitHub_recipes_on_sub-items.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Board discussions",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:02:51.811Z","linkedPulseIds":[{"linkedPulseId":4392298202}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:03:42.014Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:05:05.909Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2024-01-03T10:08:28.380Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Communicate across your board with Board Discussions"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Communicating with your team has never been so easy. In addition to the updates section, you can now communicate across your board as a whole using Board Discussions.","changed_at":"2023-12-06T08:42:15.673Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-29","changed_at":"2024-01-03T11:22:58.176Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-06T13:23:11.162Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2024-01-03T12:50:10.603Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2024-01-03T10:08:02.698Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2024-01-03T10:08:08.116Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1704276333/Generator_featured%20images/Whats%20new%20page/items%20images/Board_discussions.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1704276382/Generator_featured%20images/Whats%20new%20page/items%20images/Board_discussions_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:03:45.093Z","linkedPulseIds":[{"linkedPulseId":5634401073}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms new duplicate question feature",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:03:00.010Z","linkedPulseIds":[{"linkedPulseId":5412490097}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:03:33.114Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:05:05.909Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-13T14:08:49.105Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Duplicate questions on your WorkForm"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"With the new \\"Duplicate\\" button, form creators can now duplicate questions easily, saving time when creating similar questions in long forms.","changed_at":"2023-12-06T08:57:43.886Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-12-04","changed_at":"2023-12-13T14:08:00.427Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-12-13T14:08:15.150Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-12-13T14:08:17.546Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-12-13T14:08:20.202Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"","text":"","changed_at":"2023-12-13T14:08:32.088Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[{"name":"Untitled","fileId":"09556a68-cb43-1071-dabe-6e317a3d5ad7","isImage":"false","fileType":"MONDAY_DOC","objectId":5677462050,"createdAt":1702460373569,"createdBy":"48570155","linkToFile":"https://monday.monday.com/docs/5677462050"}]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1702476466/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_new_duplicate_question_feature.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1702476466/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_new_duplicate_question_feature.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2023-12-06T02:03:36.146Z","linkedPulseIds":[{"linkedPulseId":5634400570}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Improve automation and integration usage page",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:22.456Z","linkedPulseIds":[{"linkedPulseId":5160349343}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:48.619Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-11-08T14:59:40.225Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-29T19:00:21.078Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved automations and integrations usage page"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Clearer and more aesthetically pleasing, admins can keep track of automation and integration usage on the new and improved usage page. In addition, admins can now view the names of private boards in the account.","changed_at":"2023-11-29T18:45:57.264Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-27","changed_at":"2023-11-29T18:43:19.906Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-11-29T18:44:00.972Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-11-29T18:50:26.319Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-11-29T18:46:02.090Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360017556179#track_actions","text":"Automation and Integration Actions"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1701283259/Generator_featured%20images/Whats%20new%20page/items%20images/Improve_automation_and_integration_usage_page.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1701283259/Generator_featured%20images/Whats%20new%20page/items%20images/Improve_automation_and_integration_usage_page.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: 'Assign team as board owner using automation ("Create board from template")',
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:07.828Z","linkedPulseIds":[{"linkedPulseId":5319317656}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:38.398Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-11-08T14:59:40.225Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-01T12:56:41.365Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Use automations to assign a team as board owner"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now use an automation to instantly assign a team as the owner of a new board created from a template.","changed_at":"2023-12-01T12:53:01.877Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-28","changed_at":"2023-12-03T15:43:47.190Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-12-01T12:56:28.703Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-12-01T12:56:31.209Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-12-01T12:56:33.999Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1701435137/Generator_featured%20images/Whats%20new%20page/items%20images/Assign_team_as_board_owner_using_automation__Create_board_from_template_.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1701435137/Generator_featured%20images/Whats%20new%20page/items%20images/Assign_team_as_board_owner_using_automation__Create_board_from_template_.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "More details in the automation builder",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:41:46.304Z","linkedPulseIds":[{"linkedPulseId":5266339676}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:41:51.750Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:41:54.902Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-22T14:12:32.208Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"More actions and details in the automation builder"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"A brand new header and sidebar give more information about the automation and allow for quick actions right inside the automation builder.","changed_at":"2023-11-19T11:17:15.761Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-20","changed_at":"2023-11-22T14:07:36.373Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-11-22T14:11:21.471Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-11-22T14:11:26.372Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-11-22T14:11:23.270Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/15485449493394","text":"Managing your automations"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[{"name":"Untitled","fileId":"a90cf27c-6c4d-fc9b-d352-8e2c57ef01d1","isImage":"false","fileType":"MONDAY_DOC","objectId":5521929369,"createdAt":1700126458918,"createdBy":"48570155","linkToFile":"https://monday.monday.com/docs/5521929369"}]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1700662016/Generator_featured%20images/Whats%20new%20page/items%20images/More_details_in_the_automation_builder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1700662016/Generator_featured%20images/Whats%20new%20page/items%20images/More_details_in_the_automation_builder.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Hide subitems columns",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:30.104Z","linkedPulseIds":[{"linkedPulseId":5417742217}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:46.260Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-11-08T14:59:40.225Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-22T13:29:43.511Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Hide subitem columns from your board"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Looking to further customize the data displayed on your board? You can now hide columns from your subitems to help display the most relevant information to you at all times.","changed_at":"2023-11-14T13:55:26.698Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-16","changed_at":"2023-11-14T13:55:28.362Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-11-14T13:55:54.601Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-11-14T13:55:58.249Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2024-02-01T13:02:53.013Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003384039","text":"Hiding columns from your board"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1700659452/Generator_featured%20images/Whats%20new%20page/items%20images/Hide_subitems_columns.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1700659452/Generator_featured%20images/Whats%20new%20page/items%20images/Hide_subitems_columns.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: '"When subitem status change" automation trigger',
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-04T12:31:43.796Z","linkedPulseIds":[{"linkedPulseId":5105104610}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-04T12:34:51.698Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-06T15:27:20.398Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Expanded capabilities for subitems and custom automations"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"When creating custom automations, you now have the option to use a subitem status change to initiate an automated action.","changed_at":"2023-10-26T14:25:30.066Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-03","changed_at":"2023-11-06T15:26:36.368Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-06T15:26:57.796Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-11-06T15:27:02.357Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-11-06T15:27:03.872Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360017311219#01GQY58AXKWWD8BZAABNY6RATQ","text":"Subitems and automations"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1699284362/Generator_featured%20images/Whats%20new%20page/items%20images/whats_new_When_subitem_status_change__automation_trigger.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1699284362/Generator_featured%20images/Whats%20new%20page/items%20images/whats_new_When_subitem_status_change__automation_trigger.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Action level automation activity log",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-04T12:31:53.239Z","linkedPulseIds":[{"linkedPulseId":5099380717}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-04T12:36:00.558Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-13T13:31:27.100Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"More visibility in automation activity log"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We’ve expanded the capabilities of the automation activity log. Now you can see if every trigger, condition, and action in an automation recipe has succeeded or failed.","changed_at":"2023-10-26T14:25:12.624Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-08","changed_at":"2023-11-06T15:27:16.757Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-11-13T13:31:09.023Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-11-13T13:31:15.333Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-11-13T13:31:20.610Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360017254600","text":"Automation Activity Log"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1699881791/Generator_featured%20images/Whats%20new%20page/items%20images/Action_level_automation_activity_log.jpg"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1699881791/Generator_featured%20images/Whats%20new%20page/items%20images/Action_level_automation_activity_log.jpg"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Ability to filter by the date of creation log and last update columns",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:12.922Z","linkedPulseIds":[{"linkedPulseId":5389415066}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-11-08T16:30:43.557Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-11-08T14:59:40.225Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-12-01T12:46:32.825Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Expanded filtering abilities"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now filter your board according to the dates from your Creation Log and Last Updated Columns, allowing you to zoom into the exact data you need.","changed_at":"2023-12-01T12:45:30.725Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-29","changed_at":"2023-12-01T12:53:10.216Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-11-14T13:52:13.113Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-11-14T13:52:15.893Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-11-14T13:52:20.475Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001140029-The-Creation-Log-Column#filter_it","text":"The Creation Log Column"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1701434685/Generator_featured%20images/Whats%20new%20page/items%20images/Ability_to_filter_by_the_date_of_creation_log_and_last_update_columns.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1701434685/Generator_featured%20images/Whats%20new%20page/items%20images/Ability_to_filter_by_the_date_of_creation_log_and_last_update_columns.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "November roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-11-02","changed_at":"2023-12-03T19:59:46.683Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"CwjW8yIK8x0"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Pause notifications",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-04T07:49:17.259Z","linkedPulseIds":[{"linkedPulseId":4899108919}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-17T10:55:22.918Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T12:57:06.450Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Pause notifications on your mobile app"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Android users can now choose to temporarily pause all notifications for the duration of their choosing.","changed_at":"2023-10-19T08:35:32.874Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-17","changed_at":"2023-10-29T12:44:52.639Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T12:45:13.131Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-29T12:45:19.306Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-29T12:45:16.570Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360015803179#Stay_in_the_know","text":"How to get started with the mobile app"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698584204/Generator_featured%20images/Whats%20new%20page/items%20images/Pause_notifications.jpg"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698584204/Generator_featured%20images/Whats%20new%20page/items%20images/Pause_notifications.jpg"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2023-10-17T10:55:25.876Z","linkedPulseIds":[{"linkedPulseId":5341729651}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Quick item creation from a form",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-04T07:49:26.407Z","linkedPulseIds":[{"linkedPulseId":3731673599}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-04T11:48:04.763Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T12:58:53.432Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Create new contacts from a form"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"monday CRM subscribers can now enable their team to easily create new contacts from a form with mandatory fields clearly indicated.","changed_at":"2023-10-29T12:57:54.459Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-19","changed_at":"2023-10-29T12:57:58.552Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T12:58:14.383Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-10-29T12:58:17.032Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-29T12:58:20.639Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005311909#quick_item_creation_form","text":"Manage your CRM contacts"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698584316/Generator_featured%20images/Whats%20new%20page/items%20images/Quick_item_creation_from_a_form.jpg"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698584316/Generator_featured%20images/Whats%20new%20page/items%20images/Quick_item_creation_from_a_form.jpg"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Set response limit on forms",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-16T13:43:43.904Z","linkedPulseIds":[{"linkedPulseId":5083269854}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-17T10:55:28.406Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-24T15:47:12.692Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Set a response limit to your WorkForm"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Set a response limit on your WorkForm to cap the amount of responses you receive in order to manage capacity.","changed_at":"2023-10-24T15:43:06.119Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-12","changed_at":"2023-10-24T15:43:15.696Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-10-24T15:47:02.125Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-24T15:43:46.244Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-24T15:43:48.792Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-24T15:43:50.540Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11040473466258","text":"WorkForms settings and permissions"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698162406/Generator_featured%20images/Whats%20new%20page/items%20images/Set_response_limit_on_forms.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698162406/Generator_featured%20images/Whats%20new%20page/items%20images/Set_response_limit_on_forms.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2023-10-17T10:55:31.529Z","linkedPulseIds":[{"linkedPulseId":5341730103}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms Welcome Page!",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-16T13:44:00.163Z","linkedPulseIds":[{"linkedPulseId":5192588392}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-17T10:55:32.467Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-16T13:44:09.477Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T15:39:45.892Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Create a welcome screen for your form"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now add and customize a welcome screen for submitters to begin their journey in completing your WorkForm.","changed_at":"2023-10-19T08:32:08.106Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-23","changed_at":"2023-10-29T15:38:31.057Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T15:38:40.917Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-29T15:38:43.049Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-29T15:38:48.790Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11040473466258#adjust_your_workform_settings","text":"https://support.monday.com/hc/en-us/articles/11040473466258#adjust_your_workform_settings"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698593955/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_Welcome_Page.jpg"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1698593955/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_Welcome_Page.jpg"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: '{"changed_at":"2023-10-17T10:55:35.446Z","linkedPulseIds":[{"linkedPulseId":5341730431}]}'
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Transfer integrations before disabling a user",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-04T07:49:42.824Z","linkedPulseIds":[{"linkedPulseId":4896053753}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-04T12:33:25.493Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T15:41:15.305Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"New admin capabilities for integrations"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We’ve added the ability for an admin to transfer all of a user’s integrations to another user. The transferred integrations will be deactivated so that the new owner can reactivate them using their own credentials.","changed_at":"2023-10-26T14:24:40.239Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-25","changed_at":"2023-10-29T15:40:38.652Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-29T15:40:58.448Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-29T15:41:00.899Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-29T15:41:02.566Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/12348047493906#h_01HDQAYTSYFATM2JAD6JP2NCJF","text":"What to do when a member leaves your account"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1697368964/Generator_featured%20images/Whats%20new%20page/items%20images/Transfer_integrations_before_disabling_a_user.jpg"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1697368964/Generator_featured%20images/Whats%20new%20page/items%20images/Transfer_integrations_before_disabling_a_user.jpg"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Team as dashboard owner",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-10-04T07:49:33.416Z","linkedPulseIds":[{"linkedPulseId":4640536126}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-04T11:47:54.525Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-08T09:54:34.422Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-15T11:29:32.009Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Set a team as a dashboard owner"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Allow all members of a team to instantly have ownership of a dashboard, so that all relevant people will be able to customize it with ease.","changed_at":"2023-10-15T11:36:08.532Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-10","changed_at":"2023-10-15T11:27:36.095Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-15T11:28:05.857Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-15T11:28:08.598Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-15T11:28:10.408Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005884405-All-about-teams#manage_your_team","text":"https://support.monday.com/hc/en-us/articles/115005884405-All-about-teams#manage_your_team"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1697369039/Generator_featured%20images/Whats%20new%20page/items%20images/Team_as_dashboard_owner_121023.jpg"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1697369039/Generator_featured%20images/Whats%20new%20page/items%20images/Team_as_dashboard_owner_121023.jpg"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Account has reached it's automation action quota indication",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-18T14:07:52.292Z","linkedPulseIds":[{"linkedPulseId":5069357313},{"linkedPulseId":4739780265},{"linkedPulseId":5069569099}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-18T14:08:18.248Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-04T12:58:38.614Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Clarity on automation actions"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve upgraded the way we notify you about certain automation actions and errors to help increase transparency and make it easier to understand how an automation performed.","changed_at":"2023-10-04T12:58:16.150Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-06","changed_at":"2023-10-15T11:47:56.387Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[106,160]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-10-04T12:55:14.282Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-04T12:55:16.088Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-04T12:55:17.995Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001222900-monday-com-Automations","text":"monday.com Automations"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696424215/Generator_featured%20images/Whats%20new%20page/items%20images/Account_has_reached.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696424215/Generator_featured%20images/Whats%20new%20page/items%20images/Account_has_reached.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Marketplace Store - Filters MVP",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-18T14:18:34.921Z","linkedPulseIds":[{"linkedPulseId":4788055702}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-18T14:18:36.956Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-04T07:48:15.941Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Filters in the apps marketplace"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Use the new filters on the monday apps marketplace for smoother navigation and so that you can instantly find the exact apps you need.","changed_at":"2023-10-10T09:18:04.083Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-04","changed_at":"2023-10-15T11:47:58.837Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-04T07:45:05.391Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-04T07:45:07.002Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-04T07:45:08.852Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360014664060-The-monday-apps-marketplace","text":"The monday apps marketplace"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696405628/Generator_featured%20images/Whats%20new%20page/items%20images/Marketplace_Store_-_Filters_MVP.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696405628/Generator_featured%20images/Whats%20new%20page/items%20images/Marketplace_Store_-_Filters_MVP.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Accessibility improvement on  Account and workspace permission pages",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-20T07:56:59.069Z","linkedPulseIds":[{"linkedPulseId":4828520045}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-20T07:57:00.564Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-01T09:07:56.964Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved accessibility for permission management"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"In accordance with the W3C Accessibility Standards, we now offer seamless keyboard navigation as well as the option to use a screen reader within the the Account and Workspace permission pages.","changed_at":"2023-10-01T09:04:40.122Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-03","changed_at":"2023-10-15T11:54:54.468Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,166]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-01T09:05:02.562Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-01T09:05:05.966Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-01T09:05:12.720Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000571925","text":"Accessibility"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696151243/Generator_featured%20images/Whats%20new%20page/items%20images/accessibility_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696151243/Generator_featured%20images/Whats%20new%20page/items%20images/accessibility_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Microsoft Power Automate",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-10-10T08:25:02.563Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-10T08:24:31.345Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Microsoft Power Automate"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Create objects and trigger Power Automate flows from events with Power Automate integration","changed_at":"2023-10-10T08:22:46.355Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-10","changed_at":"2023-10-10T08:22:53.352Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-10-10T08:25:24.796Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-10-10T08:23:20.233Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-10T08:23:22.153Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000270","text":"https://monday.com/marketplace/10000270"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696926249/Generator_featured%20images/Whats%20new%20page/items%20images/Microsoft_power_automate.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1696926249/Generator_featured%20images/Whats%20new%20page/items%20images/Microsoft_power_automate.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "October roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-10-02","changed_at":"2023-11-06T21:54:08.561Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"Htii45AZL7Q"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Mass email analytics",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-06T08:06:20.035Z","linkedPulseIds":[{"linkedPulseId":5106562228}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-06T08:06:24.398Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-09T07:46:29.560Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T18:25:23.493Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Analyze mass email performance"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Mass email analytics help you to streamline the performance of your campaigns by giving your team visibility into your target audience\'s engagement.","changed_at":"2023-09-20T18:52:14.767Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-28","changed_at":"2023-09-28T18:25:17.138Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,4,165,159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T18:24:20.205Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-09-28T17:34:33.248Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-09-28T18:24:22.664Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/13093369125778-Mass-email-tracking","text":"Mass email tracking"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695925427/Generator_featured%20images/Whats%20new%20page/items%20images/Mass_email_analytics_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695925427/Generator_featured%20images/Whats%20new%20page/items%20images/Mass_email_analytics_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Dependency types + lead/lag",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-04T12:30:38.088Z","linkedPulseIds":[{"linkedPulseId":3484155026}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-04T12:31:26.658Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T18:25:28.796Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Advanced dependencies"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Take your project management capabilities up a notch with dependency types, or by adding lead or lag times to define any necessary delays or opportunities to save time.","changed_at":"2023-09-28T17:34:03.234Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-24","changed_at":"2023-09-28T17:34:05.274Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-04T12:39:46.380Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[7]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-09-04T12:54:11.617Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-09-28T13:38:59.127Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-09-28T13:38:55.845Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360007402599-Dependencies-on-monday-com#dependency_types","text":"Dependencies on monday.com"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695922495/Generator_featured%20images/Whats%20new%20page/items%20images/highlight.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695922404/Generator_featured%20images/Whats%20new%20page/items%20images/lag.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "monday AI assistant - Docs",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-04T12:27:17.622Z","linkedPulseIds":[{"linkedPulseId":4390691595}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-04T12:27:56.400Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T13:34:57.962Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"AI Assistant within WorkDocs"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Needing to create a summary of your workdoc to highlight the keypoints? With monday AI Assistant this can be done with a single click.","changed_at":"2023-09-04T14:27:08.766Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-23","changed_at":"2023-09-28T13:38:49.195Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-09-04T14:44:25.460Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-09-04T14:31:55.325Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-09-04T14:44:30.528Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360021702939#h_01H5MRJND61N86920FB7B19TJ5","text":"monday workdocs"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695908053/Generator_featured%20images/Whats%20new%20page/items%20images/monday_AI_assistant_-_Docs.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695908053/Generator_featured%20images/Whats%20new%20page/items%20images/monday_AI_assistant_-_Docs.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Availability management",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-09-04T12:30:14.071Z","linkedPulseIds":[{"linkedPulseId":4588754702}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-09-04T12:30:18.208Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T17:52:57.292Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Workload availability management"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Do you have multiple users on your account, each with different work schedules? The Workload widget can now be customized based on the work schedule for each user!","changed_at":"2023-09-04T13:44:47.779Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-20","changed_at":"2023-09-28T13:38:46.511Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T13:36:45.218Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-09-04T13:48:34.244Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-09-28T13:36:47.136Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010699760#workload_availability_management","text":"The Workload view and widget"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695908130/Generator_featured%20images/Whats%20new%20page/items%20images/Availability_management.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695908130/Generator_featured%20images/Whats%20new%20page/items%20images/Availability_management.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "monday AI assistant - Sales email composer",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-30T11:28:30.135Z","linkedPulseIds":[{"linkedPulseId":4392456737}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-30T11:29:01.353Z","personsAndTeams":[{"id":7102342,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-21T10:42:07.221Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"AI Assistant within Emails & Activities"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"monday AI Assistant is ready to help you generate the perfect email. You can now use monday AI with Emails &amp; Activities.","changed_at":"2023-09-20T18:22:54.337Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-18","changed_at":"2023-09-28T13:38:10.860Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,158,160]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-09-20T18:23:35.153Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-09-20T18:23:39.644Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-09-18T13:43:44.014Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11512670770834-Get-started-monday-AI","text":"Get started: monday AI"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695292915/Generator_featured%20images/Whats%20new%20page/items%20images/monday_AI_assistant_-_Sales_email_composer.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1695292915/Generator_featured%20images/Whats%20new%20page/items%20images/monday_AI_assistant_-_Sales_email_composer.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "View lock permissions",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-30T11:28:56.439Z","linkedPulseIds":[{"linkedPulseId":4392840822}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-30T11:28:58.283Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-12T08:06:00.635Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Lock your views to prevent unwanted edits"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now lock a customized board view that you created in order to prevent others from changing or editing it!","changed_at":"2023-09-12T08:38:42.358Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-08","changed_at":"2023-09-12T08:03:48.254Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-30T11:40:11.634Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-11-14T13:58:29.635Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-30T11:47:11.464Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-11-14T13:58:27.436Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001267945#lock_view","text":"The board views"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1694505918/Generator_featured%20images/Whats%20new%20page/items%20images/highlight_View_lock_permissions.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1694505887/Generator_featured%20images/Whats%20new%20page/items%20images/View_lock_permissions.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Priority column for My Work",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-29T12:38:26.062Z","linkedPulseIds":[{"linkedPulseId":4896600435}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-30T11:33:19.268Z","personsAndTeams":[{"id":43357589,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-28T12:20:55.153Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Priority column on My Work"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"My Work now supports the priority column so that you can keep track of all your tasks and their deadlines.","changed_at":"2023-09-04T14:38:10.722Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-06","changed_at":"2023-09-12T07:51:55.266Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-09-04T14:43:57.675Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-09-04T14:44:45.324Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-09-04T14:44:49.320Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019300579","text":"My Work"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1694505156/Generator_featured%20images/Whats%20new%20page/items%20images/Priority_column_for_My_Work_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1694505156/Generator_featured%20images/Whats%20new%20page/items%20images/Priority_column_for_My_Work_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Date column revamp",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-22T07:45:14.606Z","linkedPulseIds":[{"linkedPulseId":4546489621}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-22T07:45:16.795Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-12T07:50:48.805Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Date Column revamp"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"The Date Column has been fully reworked with a new date picker that provides a smoother and more accessible data inputting experience.","changed_at":"2023-09-12T07:50:40.084Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-04","changed_at":"2023-09-12T07:49:59.955Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-12T07:50:02.504Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,166]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-10-17T12:01:02.609Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-09-12T07:47:54.009Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-10-17T12:01:06.537Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000317520-The-Date-Column","text":"The Date Column"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1694504776/Generator_featured%20images/Whats%20new%20page/items%20images/highlight_Date_column_revamp.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1694504798/Generator_featured%20images/Whats%20new%20page/items%20images/Date_column_revamp.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "September roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-09-02","changed_at":"2023-10-17T15:51:34.637Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"gMbERJ7vhBA"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Save workspace as template",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-28T07:39:11.095Z","linkedPulseIds":[{"linkedPulseId":4835033408}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-28T07:33:30.287Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-31T15:59:55.473Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Template your Workspace"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Available on the Pro and Enterprise plans, you can now save your favorite workspaces full of boards, dashboards, workdocs, and more as a template for any team to use.","changed_at":"2023-10-02T08:58:19.143Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-30","changed_at":"2023-08-31T16:00:04.386Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-28T07:35:27.820Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-28T07:35:30.235Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-28T07:35:33.323Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010785460-The-Workspaces#01H8BP4XBCGAQXN6BD8WV5RPH0","text":"The Workspaces"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1693497556/Generator_featured%20images/Whats%20new%20page/items%20images/Save_workspace_as_template.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1693497556/Generator_featured%20images/Whats%20new%20page/items%20images/Save_workspace_as_template.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "HTML email editor",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-09T12:24:24.952Z","linkedPulseIds":[{"linkedPulseId":4740018187}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-14T11:16:35.896Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-31T15:58:42.784Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"HTML email editor on Emails and Activities"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Fully customize and brand the emails that you send on Emails and Activities by using HTML code within the email editor.","changed_at":"2023-08-17T08:37:13.029Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-29","changed_at":"2023-08-31T15:57:51.352Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-19T11:40:49.733Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-08-17T08:36:59.719Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-09-19T11:40:46.380Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019213180-Emails-Activities-on-monday-com","text":"Emails & Activities on monday.com"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1693497439/Generator_featured%20images/Whats%20new%20page/items%20images/HTML_Email_editor.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1693497439/Generator_featured%20images/Whats%20new%20page/items%20images/HTML_Email_editor.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms new Submissions Analytics Page!",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-09T12:24:18.692Z","linkedPulseIds":[{"linkedPulseId":4778914932}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-14T11:16:35.896Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-30T07:48:15.479Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"WorkForms submissions analytics page"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Make data driven decisions and gain form insights such as submission rate, geolocation, average submission time, and more by using the new WorkForms analytics page.","changed_at":"2023-08-17T13:06:43.331Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-24","changed_at":"2023-08-17T08:36:33.313Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,162,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-30T07:46:41.557Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-17T13:07:17.357Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-30T07:46:43.140Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000358700#collect_and_analyze_results","text":"All about monday WorkForms"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1692615591/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_new_Submissions_Analytics_Page_thumbnail.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1692615591/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_new_Submissions_Analytics_Page_thumbnail.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Team as owner of board/docs",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-09T12:24:10.949Z","linkedPulseIds":[{"linkedPulseId":4717762988}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-14T11:16:35.896Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: '{"changed_at":"2023-10-10T12:59:28.827Z","personsAndTeams":[{"id":48570155,"kind":"person"}]}'
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-28T09:38:37.241Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Set a team as a board or doc owner"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Give all the members of a team ownership of a board or doc in one click, so that all the relevant people will have permissions to make changes with ease.","changed_at":"2023-08-17T08:17:33.921Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-22","changed_at":"2023-08-17T08:18:17.728Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-09-19T11:40:40.125Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-17T08:21:25.674Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-09-19T11:40:41.803Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005884405-All-about-teams#manage_your_team","text":"All about teams"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1693215502/Generator_featured%20images/Whats%20new%20page/items%20images/Team_ownership.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1693215502/Generator_featured%20images/Whats%20new%20page/items%20images/Team_ownership.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Custom cover photo",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:38:54.707Z","linkedPulseIds":[{"linkedPulseId":4896394284}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-13T10:07:05.833Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Personalize your workdoc cover photo"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Add your own custom photo or GIF as the cover photo of your workdoc to customize and brand it as you wish.","changed_at":"2023-08-08T05:55:37.498Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-07","changed_at":"2023-08-08T06:10:18.105Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:45:40.904Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-07T12:46:27.867Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:46:40.165Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360021702939-monday-workdocs#Doc_settings","text":"monday workdocs"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691935105/Generator_featured%20images/Whats%20new%20page/items%20images/Group_1261161798_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691935105/Generator_featured%20images/Whats%20new%20page/items%20images/Group_1261161798_2.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Reactions",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:38:24.346Z","linkedPulseIds":[{"linkedPulseId":3931122299}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-08T09:00:29.129Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"React to updates with Emojis"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Use Emojis as reactions to updates to better communicate, save time, and for a fun way to express support or celebrate accomplishments.","changed_at":"2023-08-10T09:10:24.510Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-04","changed_at":"2023-08-08T06:09:50.433Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:58:40.998Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[158,157]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:45:21.876Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-07T12:45:51.775Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:46:40.165Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005900249#like_and_reply","text":"The Updates Section"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691488095/Generator_featured%20images/Whats%20new%20page/items%20images/reactions.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691485142/Generator_featured%20images/Whats%20new%20page/items%20images/reaction.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Kanban overview navigational battery",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-08T06:09:18.716Z","linkedPulseIds":[{"linkedPulseId":4584521981}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-09T09:55:42.219Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Kanban navigational improvements"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We added a new battery-style widget at the top of your Kanban for easy navigation through your cards and a better understanding of what has been achieved.","changed_at":"2023-08-10T09:11:31.912Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-02","changed_at":"2023-08-16T18:38:03.931Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:45:33.408Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-08-07T12:45:56.541Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:46:40.165Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000661379","text":"The Kanban View"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691935229/Generator_featured%20images/Whats%20new%20page/items%20images/Kanbann_dev_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691935229/Generator_featured%20images/Whats%20new%20page/items%20images/Kanbann_dev_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Inbox improvements",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:37:51.906Z","linkedPulseIds":[{"linkedPulseId":4392298194}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-14T08:43:49.843Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Introducing the new Update Feed"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Oversee all your updates using the Update Feed! With improved navigation, robust customization options, the option to clear all updates, and more, managing your work has never been easier.","changed_at":"2023-08-08T06:05:17.318Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-02","changed_at":"2023-08-08T06:09:36.863Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:58:44.740Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,161,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-08-07T12:45:18.981Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-08-07T12:45:49.487Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:46:40.165Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005309885","text":"The Update Feed (Inbox)"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1692002553/Generator_featured%20images/Whats%20new%20page/items%20images/inbox_feed.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691931825/Generator_featured%20images/Whats%20new%20page/items%20images/Inbox_improvment.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "August roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-08-02","changed_at":"2023-09-18T13:40:27.873Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"a2F8Hd70ig0"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "AI assistant - formula builder",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-19T09:50:14.441Z","linkedPulseIds":[{"linkedPulseId":4390403896}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-17T11:21:27.903Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-22T14:19:19.267Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Build formulas with ease using monday AI"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Create a complex formula in seconds using the new formula AI builder, simply by stating the calculation that you need!","changed_at":"2023-07-23T12:03:09.543Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-23","changed_at":"2023-07-23T12:03:13.863Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-23T12:04:02.384Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-08-22T14:19:16.133Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-19T09:54:09.208Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-07-19T09:54:20.523Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001235445-The-Formula-Column#AI_formula_builder","text":"https://support.monday.com/hc/en-us/articles/360001235445-The-Formula-Column#AI_formula_builder"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1690118043/Generator_featured%20images/Whats%20new%20page/items%20images/aiassistent.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689760095/Generator_featured%20images/Whats%20new%20page/items%20images/AI_formula_assistant.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Connect sub item to an item in another board using automations",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:25:35.455Z","linkedPulseIds":[{"linkedPulseId":4661599863}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-17T11:21:30.182Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-27T14:05:28.008Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Automatically connect subitems to items"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Take your workflow up a notch by instantly connecting a subitem to an item on another board using automations.","changed_at":"2023-07-27T14:05:14.058Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-20","changed_at":"2023-07-27T14:03:58.633Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-07-27T14:04:34.941Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-27T14:04:36.710Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-27T14:04:39.255Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001222900-monday-com-Automations","text":"monday.com Automations"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1690466147/Generator_featured%20images/Whats%20new%20page/items%20images/Connect_subitem.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1690466147/Generator_featured%20images/Whats%20new%20page/items%20images/Connect_subitem.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Transfer automations before disabling a user",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:25:43.568Z","linkedPulseIds":[{"linkedPulseId":4561653637}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:27:58.759Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-19T10:07:48.673Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Transfer automations before user deactivation"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Seamlessly transfer automation ownership prior to deactivating a user on your account, right from the user management page.","changed_at":"2023-07-19T10:07:46.001Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-19","changed_at":"2023-07-19T10:03:28.904Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-19T10:05:23.770Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-19T10:05:25.464Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-19T10:05:27.609Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360002426980#how_to_deactivate_user","text":"How to manage users on your account"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689760853/Generator_featured%20images/Whats%20new%20page/items%20images/Deactivate_users.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689760853/Generator_featured%20images/Whats%20new%20page/items%20images/Deactivate_users.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms people column question!",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:22:33.801Z","linkedPulseIds":[{"linkedPulseId":4252288662}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:27:58.759Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-09T09:18:05.894Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Use the People Column in a monday WorkForm"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Add a People Column to your WorkForm to easily assign an item to a specific person or team without having to create an automation on your board!","changed_at":"2023-07-13T12:28:17.956Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-16","changed_at":"2023-07-13T12:26:35.983Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-07-13T12:26:54.753Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-13T12:26:58.473Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-19T09:54:25.661Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/14124262264978#choose_your_question_type","text":"Build out your WorkForm"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691572641/Generator_featured%20images/Whats%20new%20page/items%20images/form_q.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691572641/Generator_featured%20images/Whats%20new%20page/items%20images/form_q.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Last lead activity date at a glance",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:23:10.860Z","linkedPulseIds":[{"linkedPulseId":4392465300}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:27:58.759Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-18T08:25:18.089Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Instantly understand last lead activity"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"As part of Emails and Activities, you can now use an integration recipe to automatically update a Date Column every time that an activity or email was captured.","changed_at":"2023-07-19T09:14:11.399Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-16","changed_at":"2023-07-16T12:16:33.878Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,106,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-07-16T12:16:52.106Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-16T12:16:57.275Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-16T12:17:10.738Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019213180-Emails-Activities-on-monday-com","text":"Emails & Activities on monday.com"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689668646/Generator_featured%20images/Whats%20new%20page/items%20images/Last_lead_activity_date_at_a_glance.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689668646/Generator_featured%20images/Whats%20new%20page/items%20images/Last_lead_activity_date_at_a_glance.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "New monday Layout",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:26:19.969Z","linkedPulseIds":[{"linkedPulseId":3637604711}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-13T12:02:54.845Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-18T08:03:51.759Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"monday.com has a new look!"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve renovated the monday.com layout to support lots of newly added features, and to make account navigation smoother than ever.","changed_at":"2023-08-10T09:10:48.753Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-13","changed_at":"2023-07-13T12:03:27.308Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-13T12:02:45.478Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,166]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-13T12:03:45.239Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-13T12:03:46.994Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-09-19T11:40:58.163Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11398061101714-Introducing-monday-com-s-new-look","text":"Introducing monday.com\'s new look"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689671695/Generator_featured%20images/Whats%20new%20page/items%20images/newlayout.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689755276/Generator_featured%20images/Whats%20new%20page/items%20images/new_layout.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "monday AI assistant - task generator",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:26:00.315Z","linkedPulseIds":[{"linkedPulseId":4390495973}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-12T14:27:58.759Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-08-08T06:12:32.271Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Instantly create tasks using monday AI"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Create up to 15 new items at a time according to your specific needs using AI-generated task suggestions.","changed_at":"2023-07-13T11:57:49.447Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-06","changed_at":"2023-07-13T12:00:57.644Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-07-13T12:02:15.167Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-08-23T07:26:30.367Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-13T11:58:30.489Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-07-13T11:58:32.113Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11512670770834-Get-started-monday-AI","text":"Get started: monday AI"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689667496/Generator_featured%20images/Whats%20new%20page/items%20images/AI_task_generator_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1689667496/Generator_featured%20images/Whats%20new%20page/items%20images/AI_task_generator_2.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "July roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-27T13:57:12.261Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-07-02","changed_at":"2023-08-23T07:40:08.568Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"8dX2hUts0qI"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Live Spreadsheets",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Subitem Templates",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-26T13:28:01.010Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-10-10T08:18:20.687Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Subitem Templates"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Efficiently manage recurring tasks with subitem templates","changed_at":"2023-06-26T14:00:53.024Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-27","changed_at":"2023-06-26T13:44:07.028Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-26T13:44:27.405Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-26T13:44:31.466Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/104?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending","text":"https://monday.com/marketplace/104?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-06-26T14:02:51.062Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688372082/Generator_featured%20images/Whats%20new%20page/items%20images/subitems_templates.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688372082/Generator_featured%20images/Whats%20new%20page/items%20images/subitems_templates.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Microsoft 365 Office Embedded",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-26T14:00:28.358Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Microsoft 365 Office Embedded"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Integrate Office files within your monday workspace","changed_at":"2023-06-26T14:00:47.235Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-27","changed_at":"2023-06-26T14:03:21.910Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-26T14:01:10.133Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-26T14:01:11.526Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000076?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending","text":"https://monday.com/marketplace/10000076?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-06-26T14:03:35.848Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688372175/Generator_featured%20images/Whats%20new%20page/items%20images/microsoft-365-app-icon-blue.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688372175/Generator_featured%20images/Whats%20new%20page/items%20images/microsoft-365-app-icon-blue.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Item Description",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-26T14:07:08.187Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Item Description"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Add detailed, rich-text descriptions to monday items","changed_at":"2023-06-26T14:07:41.557Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-26","changed_at":"2023-06-26T14:07:46.192Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-26T14:07:50.825Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-26T14:07:54.652Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000030?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending","text":"https://monday.com/marketplace/10000030?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-06-26T14:08:17.535Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688372263/Generator_featured%20images/Whats%20new%20page/items%20images/Item_Descirption.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688372263/Generator_featured%20images/Whats%20new%20page/items%20images/Item_Descirption.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Priority Pro",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-06-15T12:47:31.513Z","linkedPulseIds":[{"linkedPulseId":4555897289}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-03T11:31:50.023Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-04T11:29:38.397Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Priority Pro app"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Effortlessly prioritize your tasks with Priority Pro\'s interactive matrix. Utilize a scoring system based on Effort and Impact to enhance your decision-making.","changed_at":"2023-07-04T11:28:50.867Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-22","changed_at":"2023-07-04T11:29:08.209Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,157]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T14:39:41.564Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T14:50:14.050Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-03T14:50:17.602Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000201?utm_source=whats-new-page&utm_medium=website","text":"https://monday.com/marketplace/10000201?utm_source=whats-new-page&utm_medium=website"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T14:50:09.541Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688469984/Generator_featured%20images/Whats%20new%20page/items%20images/Priority_pro.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688469984/Generator_featured%20images/Whats%20new%20page/items%20images/Priority_pro.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "[iOS] My Work list view",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-06-25T11:38:44.127Z","linkedPulseIds":[{"linkedPulseId":4114586954}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-27T07:42:33.133Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-03T11:19:17.621Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved iOS My Work experience"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now view your mobile My Work items in a clickable list format, making it easier to understand what work needs to be done at a glance.","changed_at":"2023-07-03T11:18:56.986Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-20","changed_at":"2023-06-27T09:44:55.754Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-06-27T09:45:38.019Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-27T09:45:40.900Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-06-27T09:45:50.876Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019300579-My-Work","text":"My Work"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T11:16:33.872Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688383097/Generator_featured%20images/Whats%20new%20page/items%20images/iOS_My_Work_list_view.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688383097/Generator_featured%20images/Whats%20new%20page/items%20images/iOS_My_Work_list_view.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Additional divide by options in Kanban - Connected Board, Status",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-06-13T08:13:03.823Z","linkedPulseIds":[{"linkedPulseId":3930942364}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-13T08:13:07.102Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-06-26T13:04:15.310Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Additional divide options in Kanban"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Further customize your Kanban view by dividing the cards according to different values from your board such as the board’s groups, Status Columns, or Connect Boards Columns!","changed_at":"2023-06-26T13:02:14.387Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-15","changed_at":"2023-06-15T14:10:18.796Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-06-15T14:10:39.459Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-15T14:10:42.223Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-06-15T14:10:47.640Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000661379-The-Kanban-View#set_up_your_kanban","text":"The Kanban View"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-06-26T13:03:10.617Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1687784609/Generator_featured%20images/Whats%20new%20page/items%20images/dev_kanbann.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1687784609/Generator_featured%20images/Whats%20new%20page/items%20images/dev_kanbann.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Mandatory Fields",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-06-15T12:47:24.879Z","linkedPulseIds":[{"linkedPulseId":4555293687}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-03T11:31:50.023Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-04T11:28:14.441Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Mandatory Fields app"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"With the Mandatory Fields app, you can ensure essential data isn\'t missed. This app requires specific columns to be filled out before progressing, enhancing data input accuracy across multiple boards.","changed_at":"2023-07-03T14:38:58.691Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-14","changed_at":"2023-07-04T11:29:04.527Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T14:39:39.971Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T14:39:26.213Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-03T14:39:49.865Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000209?utm_source=whats-new-page&utm_medium=website","text":"https://monday.com/marketplace/10000209?utm_source=whats-new-page&utm_medium=website"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T14:42:45.960Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688470032/Generator_featured%20images/Whats%20new%20page/items%20images/Mandatory_fields.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688470032/Generator_featured%20images/Whats%20new%20page/items%20images/Mandatory_fields.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms one-by-one formatting",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-06-12T09:44:02.720Z","linkedPulseIds":[{"linkedPulseId":4252107589}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-12T09:44:04.789Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-06-26T12:59:06.071Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"One-by-one format for WorkForms"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Format your WorkForm so that each question will appear individually as the form is filled out, eliminating the need to navigate between questions.","changed_at":"2023-06-26T12:58:51.055Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-13","changed_at":"2023-06-13T13:30:30.098Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-06-13T13:30:42.819Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-06-13T13:30:50.028Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-07-13T12:27:10.969Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11040473466258#form_formats","text":"monday WorkForms settings and permissions"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-06-13T13:31:01.747Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1687784267/Generator_featured%20images/Whats%20new%20page/items%20images/Workforms_format.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1687784267/Generator_featured%20images/Whats%20new%20page/items%20images/Workforms_format.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Azure DevOps Integration",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-06T15:06:12.321Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Azure DevOps Integration"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Unify development processes with Azure DevOps in monday.com","changed_at":"2023-07-06T15:08:34.697Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-07","changed_at":"2023-08-24T14:08:54.626Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2,7]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-06T15:06:32.069Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-06T15:06:37.199Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000068?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended","text":"https://monday.com/marketplace/10000068?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-06T15:06:53.039Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688889092/Generator_featured%20images/Whats%20new%20page/items%20images/azure_devops.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Live Spreadsheet for monday.com",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-03T08:30:19.520Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T11:11:22.777Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Live Spreadsheet for monday.com"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Seamlessly create and manage spreadsheets monday.com","changed_at":"2023-07-13T11:36:52.879Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:10:08.325Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T08:31:11.285Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T08:31:15.939Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000173?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending","text":"https://monday.com/marketplace/10000173?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T08:31:54.594Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688373138/Generator_featured%20images/Whats%20new%20page/items%20images/Live_spreadsheet_logo.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688373138/Generator_featured%20images/Whats%20new%20page/items%20images/Live_spreadsheet_logo.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Autoboost",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-03T08:33:31.427Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Autoboost"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Enhance your monday.com automation capabilities","changed_at":"2023-07-25T10:35:32.914Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:10:05.076Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T08:33:59.998Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T08:34:01.872Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000112?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending","text":"https://monday.com/marketplace/10000112?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T08:34:41.233Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688373301/Generator_featured%20images/Whats%20new%20page/items%20images/autoboost.avif"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688373301/Generator_featured%20images/Whats%20new%20page/items%20images/autoboost.avif"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Tracket - Makes Time Work",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:46:17.821Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Tracket - Makes Time Work"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Streamline time tracking and management in monday.com","changed_at":"2023-07-25T10:35:49.268Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:10:00.931Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T09:16:03.882Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-03T09:16:05.173Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000017?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending","text":"https://monday.com/marketplace/10000017?utm_source=whats-new-page&utm_medium=website&utm_campaign=trending"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-03T09:13:35.688Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688375707/Generator_featured%20images/Whats%20new%20page/items%20images/Tracket_Appicoon_Donkerblauw.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688375707/Generator_featured%20images/Whats%20new%20page/items%20images/Tracket_Appicoon_Donkerblauw.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Automatic CSV Import",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:46:16.229Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Automatic CSV Import"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Automate data import from CSV files in monday.com","changed_at":"2023-07-25T10:35:54.838Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:55.862Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-04T11:46:44.763Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-04T11:46:46.061Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000252?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps","text":"https://monday.com/marketplace/10000252?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-04T11:46:59.221Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688471298/Generator_featured%20images/Whats%20new%20page/items%20images/automatic-csv-import-icon.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "SuperMail",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:49:06.767Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"SuperMail"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Design and automate rich-text emails within monday.com","changed_at":"2023-07-13T11:37:11.835Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:53.040Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-04T11:49:37.276Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-04T11:49:38.676Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000247?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps","text":"monday.com: Apps Marketplace"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-04T11:49:47.068Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688471422/Generator_featured%20images/Whats%20new%20page/items%20images/supermail_logo.avif"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Itemplate Wizard",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:51:01.868Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Itemplate Wizard"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Optimize monday.com with a repository of usable templates","changed_at":"2023-07-25T10:35:59.283Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:49.267Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-04T11:51:27.637Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-04T11:51:31.861Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000249?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps","text":"https://monday.com/marketplace/10000249?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-04T11:51:49.456Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688471527/Generator_featured%20images/Whats%20new%20page/items%20images/itemplate_icon.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Auto Assign",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:52:31.992Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Auto Assign"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Automate people assignments in your monday.com boards","changed_at":"2023-07-25T10:36:14.670Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:45.305Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-04T11:53:19.971Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-04T11:53:21.169Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000242?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps","text":"https://monday.com/marketplace/10000242?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-04T11:53:46.505Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688471645/Generator_featured%20images/Whats%20new%20page/items%20images/autoassign.avif"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Offsite - Chrome Extension",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:54:38.162Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Offsite - Chrome Extension"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Create tasks and capture web content in monday.com","changed_at":"2023-07-13T11:37:28.541Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:22.977Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-04T11:54:57.741Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-04T11:54:59.091Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000210?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps","text":"https://monday.com/marketplace/10000210?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-04T11:55:14.700Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688471732/Generator_featured%20images/Whats%20new%20page/items%20images/offsite.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Search In Updates",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-04T11:56:25.666Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Search In Updates"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Find any monday.com item update in seconds","changed_at":"2023-07-13T11:37:32.964Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:19.479Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-07-06T14:46:13.840Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-04T11:56:49.212Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000208?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps","text":"https://monday.com/marketplace/10000208?utm_source=whats-new-page&utm_medium=website&utm_campaign=new-apps"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-04T11:57:01.802Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688471828/Generator_featured%20images/Whats%20new%20page/items%20images/search-in-updates.avif"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Embedded Calendar Pro",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-06T14:56:55.708Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Embedded Calendar Pro"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Embed calendars into monday.com for streamlined scheduling","changed_at":"2023-07-13T11:37:41.070Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:16.066Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-06T14:56:16.584Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-06T14:56:18.531Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000088?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended","text":"https://monday.com/marketplace/10000088?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-06T14:56:32.007Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688655340/Generator_featured%20images/Whats%20new%20page/items%20images/Embedded_Calendar_Pro_icon.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Unlimited Subitems",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-06T14:59:44.058Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Unlimited Subitems"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Add endless subitem levels for detailed monday.com projects","changed_at":"2023-07-13T11:37:46.331Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:11.800Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-06T14:59:17.108Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-06T14:59:18.722Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000133?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended","text":"https://monday.com/marketplace/10000133?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-06T15:01:07.270Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688655599/Generator_featured%20images/Whats%20new%20page/items%20images/USI_Icon.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Agile Retrospectives",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-06T15:00:28.844Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Agile Retrospectives"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Run insightful retrospectives within your monday.com workspace","changed_at":"2023-07-13T11:37:59.408Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:06.655Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-06T15:00:46.369Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-06T15:00:47.953Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/124?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended","text":"https://monday.com/marketplace/124?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-06T15:01:09.139Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688655689/Generator_featured%20images/Whats%20new%20page/items%20images/App_Icon-Retros.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "GetSign",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-06T15:01:59.997Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"GetSign"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Generate and sign documents directly in monday.com","changed_at":"2023-07-19T09:26:48.659Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:09:02.593Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-06T15:02:37.618Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-06T15:02:39.056Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000190?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended","text":"https://monday.com/marketplace/10000190?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-06T15:02:46.297Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688655773/Generator_featured%20images/Whats%20new%20page/items%20images/icon_9.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Planning Poker for monday.com",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-07-06T15:03:18.806Z","personsAndTeams":[{"id":41720340,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-07-25T10:39:54.732Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Planning Poker for monday.com"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Facilitate team estimates with interactive consensus games","changed_at":"2023-07-06T15:04:29.638Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-06","changed_at":"2023-08-24T14:08:57.893Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-07-06T15:04:37.454Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-07-06T15:04:38.938Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000193?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended","text":"https://monday.com/marketplace/10000193?utm_source=whats-new-page&utm_medium=website&utm_campaign=Recommended"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-07-06T15:04:53.815Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1688655905/Generator_featured%20images/Whats%20new%20page/items%20images/Planning_Poker_1.avif"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "New CRM mobile item page",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-06-13T08:12:57.991Z","linkedPulseIds":[{"linkedPulseId":4392460825}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-06-13T08:13:05.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-06-22T10:43:18.622Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Upgraded mobile CRM item page"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve revamped the mobile CRM item page, making it easier then ever to access and update the information you need while on the go.","changed_at":"2023-06-13T08:21:25.660Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-05","changed_at":"2023-06-13T08:21:45.470Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,162,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-06-13T08:21:59.198Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-06-13T08:22:02.806Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-06-13T08:22:04.778Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8675571451282-Unique-features-found-only-in-monday-sales-CRM#item_page","text":"Unique features found only in monday CRM"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-06-13T08:23:02.523Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1690705144/Generator_featured%20images/Whats%20new%20page/items%20images/New_page_item_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-06-13T08:23:08.131Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1690705144/Generator_featured%20images/Whats%20new%20page/items%20images/New_page_item_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "June roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-06-02","changed_at":"2023-08-23T07:40:13.737Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"cSZ70Iv8_JE"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Workload widget - color by support",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-05-24T14:18:49.651Z","linkedPulseIds":[{"linkedPulseId":4113354795}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-29T14:32:59.753Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-31T09:25:18.903Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Workload Widget color customization"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now easily adjust the coloring logic of your Workload Widget according to a selected field from your board.","changed_at":"2023-05-31T09:24:43.987Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-30","changed_at":"2023-05-29T14:51:10.530Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,164,160]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-05-29T14:51:42.275Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-29T14:51:44.172Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-29T14:51:49.520Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010699760-The-Workload-View-and-Widget#Setting_up_view","text":"The Workload View and Widget","changed_at":"2023-05-29T14:55:03.295Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-29T14:55:06.387Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685525033/Generator_featured%20images/Whats%20new%20page/items%20images/workload_planning.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550054/Generator_featured%20images/Whats%20new%20page/New_assets_V2/workload_planning_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "App ratings and reviews information to developers",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-05-24T14:18:02.516Z","linkedPulseIds":[{"linkedPulseId":4049631398}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-28T12:13:38.434Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-29T14:36:44.745Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"App ratings & reviews for developers"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Use the app rating and reviews feature in the developer\'s section of the apps marketplace to easily understand how an app is evaluated by other users.","changed_at":"2023-05-29T14:36:14.904Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-29","changed_at":"2023-05-29T14:10:46.664Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[106,159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-29T14:11:02.616Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-29T14:11:09.678Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-29T14:11:11.486Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"","text":"","changed_at":"2023-05-29T14:11:26.714Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-29T14:11:29.937Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685370938/Generator_featured%20images/Whats%20new%20page/items%20images/rating.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550045/Generator_featured%20images/Whats%20new%20page/New_assets_V2/rating_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Mass emails - up to 2000 emails a day",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3731244972}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-17T07:53:09.514Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-29T09:10:05.688Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Send mass emails in one click"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Distribute thousands of personalized emails in seconds by using the mass emails feature as part of the Emails and Activities app on monday CRM.","changed_at":"2023-11-07T18:55:15.436Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-25","changed_at":"2023-05-29T09:09:31.166Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-13T12:24:11.941Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,161,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-17T08:01:56.113Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-05-17T08:02:01.570Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-30T13:21:06.821Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/10989655392914-Email-campaigns-and-mass-emailing","text":"Email campaigns and mass emailing","changed_at":"2023-05-24T08:17:59.537Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-05T06:37:34.104Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685266746/Generator_featured%20images/Whats%20new%20page/items%20images/Mass_email_message.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550044/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Mass_email_message_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Dashboard Hub for monday.com",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-30T10:11:19.168Z","personsAndTeams":[{"id":30507140,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-21T13:14:19.201Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Dashboard Hub for monday.com"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"With the Dashboard Hub app, teams can analyze, collaborate and share business data through customizable reporting dashboards with pre-built templates for different teams.\\n","changed_at":"2023-05-21T13:12:40.962Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-23","changed_at":"2023-05-23T12:47:44.497Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-04-30T10:11:45.975Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-30T10:12:03.390Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-04-30T10:12:07.150Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-30T10:12:39.539Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Dashboard Hub for monday.com.png","assetId":883913165,"isImage":"true","fileType":"ASSET","createdAt":1684668859361,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://monday.com/marketplace/10000200","text":"https://monday.com/marketplace/10000200","changed_at":"2023-05-21T13:16:12.669Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-30T10:12:43.375Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684668895/Generator_featured%20images/Whats%20new%20page/items%20images/Dashboard_Hub_for_monday.com.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-02T14:58:42.513Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550038/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Dashboard_Hub_for_monday.com_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Notifications search",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-05-28T12:12:42.488Z","linkedPulseIds":[{"linkedPulseId":3931122913}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-28T12:13:38.434Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-29T14:43:05.630Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Easily locate your notifications"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now search through your notifications using free text to help find any past communications that you\'re looking for right away.","changed_at":"2023-05-28T12:50:22.855Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-21","changed_at":"2023-05-28T12:51:20.176Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,158,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-05-28T12:51:40.652Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-28T12:51:43.318Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-28T12:51:46.000Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360015535060#filter_my_notifications","text":"Bell Notifications","changed_at":"2023-05-28T12:50:52.747Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-28T12:50:56.005Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685371274/Generator_featured%20images/Whats%20new%20page/items%20images/Notifications.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550045/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Notifications_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Automation quick reporter POC",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-05-18T11:41:09.304Z","linkedPulseIds":[{"linkedPulseId":4392434067}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-21T08:57:05.809Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-06-06T12:45:39.374Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Instantly report automation issues"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"If you ever encounter a problem with automations, you can now report it to our team with the click of a button through the automation activity log.","changed_at":"2023-06-06T12:43:16.037Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-17","changed_at":"2023-05-21T09:06:46.524Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-21T09:06:58.129Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-21T09:07:00.482Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-21T09:07:02.260Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360017254600-Automation-Activity-Log","text":"Automation Activity Log"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-29T14:11:33.866Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1686055336/Generator_featured%20images/Whats%20new%20page/items%20images/Automation_report.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "AI announcement",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4340939167}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-20T06:36:21.310Z","personsAndTeams":[{"id":30507140,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-15T15:07:40.704Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Say hello to monday AI assistant"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Launching in beta this May, the monday AI assistant brings the power of AI into your workspace, taking productivity to the next level.","changed_at":"2023-04-20T06:39:37.783Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-15","changed_at":"2023-05-15T14:41:05.911Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:34:37.597Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-08-23T07:25:56.997Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-04-20T06:40:09.754Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-05-15T14:29:04.865Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-04-20T06:40:24.117Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Ai.png","assetId":875986009,"isImage":"true","fileType":"ASSET","createdAt":1684161557846,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/11512670770834-Get-started-monday-AI","text":"Get started: monday AI"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-20T06:41:03.662Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684161768/Generator_featured%20images/Whats%20new%20page/items%20images/Ai.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550037/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Ai_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Textual search changes",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4109113578}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-05T06:34:47.026Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-14T14:13:47.085Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Enhanced board search options"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve added a filter to the board search bar, making it more efficient to narrow down on the relevant information that you need at all times.","changed_at":"2023-05-05T06:44:32.271Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-04","changed_at":"2023-05-05T06:44:39.772Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,161,159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-05-05T06:43:32.341Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-05T06:43:36.335Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-06-27T07:42:24.237Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Textual search changes.png","assetId":872047165,"isImage":"true","fileType":"ASSET","createdAt":1683811486973,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003624660#Search_bar","text":"https://support.monday.com/hc/en-us/articles/360003624660#Search_bar","changed_at":"2023-05-05T06:44:04.181Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-05T06:37:32.688Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684068750/Generator_featured%20images/Whats%20new%20page/items%20images/Textual_search_changes.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550045/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Textual_search_changes_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Trash/Archive multi select",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4115044995}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-05T06:50:03.529Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-14T14:13:45.804Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Restore multiple items at once"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Quickly restore multiple deleted or archived items in one go by using the multi-select option within the Trash and Archive sections.","changed_at":"2023-05-08T13:54:15.535Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-03","changed_at":"2023-05-08T13:54:33.952Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-05-08T13:54:48.758Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-08T13:54:51.141Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-08T13:54:53.308Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Archive multi select.png","assetId":872036288,"isImage":"true","fileType":"ASSET","createdAt":1683811089719,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005312729-The-trash-section","text":"https://support.monday.com/hc/en-us/articles/115005312729-The-trash-section","changed_at":"2023-05-08T14:00:16.773Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-08T14:00:18.399Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684068693/Generator_featured%20images/Whats%20new%20page/items%20images/Archive_multi_select.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550070/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Archive_multi_select_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Teams content list",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-05-02T14:14:54.488Z","linkedPulseIds":[{"linkedPulseId":4106859096}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-02T14:15:06.114Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-14T14:12:43.839Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"View your team\'s content"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Oversee the boards, dashboards, docs, and workspaces which your team is subscribed to by using the new \\"Content\\" tab located within a team\'s main page.","changed_at":"2023-05-05T06:44:14.977Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-02","changed_at":"2023-05-05T06:44:57.480Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,163,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-05T06:40:13.236Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-05T06:40:16.539Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-05T06:40:18.089Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Teams content list.png","assetId":872028678,"isImage":"true","fileType":"ASSET","createdAt":1683810856030,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005884405#oversee_team_content","text":"https://support.monday.com/hc/en-us/articles/115005884405#oversee_team_content","changed_at":"2023-05-05T06:37:29.296Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-05T06:37:30.889Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[{"name":"Untitled","fileId":"cfb0cba4-443f-1f96-3380-4d70b78d4f80","isImage":"false","fileType":"MONDAY_DOC","objectId":4513062352,"createdAt":1684767829122,"createdBy":"32317188","linkToFile":"https://monday.monday.com/docs/4513062352"}]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684068666/Generator_featured%20images/Whats%20new%20page/items%20images/Teams_content_list_1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550045/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Teams_content_list_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Jira integration - Conditions / Filters",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-05-21T09:04:55.343Z","linkedPulseIds":[{"linkedPulseId":3717292182}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-05-21T09:05:08.593Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-24T13:55:55.031Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Robust conditions in the Jira integration"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We’ve enhanced the conditions and filtering options within the Jira integration so you can fully customize the items and issues that are synced to your board.\\n\\n","changed_at":"2023-05-21T12:47:13.087Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-02","changed_at":"2023-05-21T12:47:27.711Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-05-21T12:47:48.253Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-05-21T12:47:52.140Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-21T12:47:53.780Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/7238716251538-The-Jira-Cloud-integration","text":"The Jira Cloud integration","changed_at":"2023-05-24T08:25:30.684Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-21T12:47:56.273Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684916764/Generator_featured%20images/Whats%20new%20page/items%20images/Filters.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550044/Generator_featured%20images/Whats%20new%20page/New_assets_V2/jira_two_way_sync_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "May roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-05-02","changed_at":"2023-08-23T07:40:17.630Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"","text":"","changed_at":"2023-05-30T08:42:08.023Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"I0hRa_dJ1ys"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms dedicated automation recipes",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-04-30T11:55:29.855Z","linkedPulseIds":[{"linkedPulseId":4378467229}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-30T11:06:54.625Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-14T14:13:50.135Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Dedicated WorkForm automation recipes"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We created unique automation recipes to use with your WorkForms to help instantly automate various actions based on a form submission.","changed_at":"2023-05-02T08:16:33.717Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-30","changed_at":"2023-05-02T08:19:43.534Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-02T08:16:56.007Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-05-02T08:17:00.481Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-05-02T08:17:02.281Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"WorkForms dedicated automation recipes.png","assetId":872060285,"isImage":"true","fileType":"ASSET","createdAt":1683811971817,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/14129260394002#automate_your_workform","text":"Share and Analyze your WorkForm"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-05-02T08:18:35.230Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684068821/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_dedicated_automation_recipes.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-02T08:23:57.425Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685610645/Generator_featured%20images/Whats%20new%20page/New_assets_V2/WorkForms_dedicated_automation_recipes_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "monday dev - Out of Beta",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-04-30T11:55:10.781Z","linkedPulseIds":[{"linkedPulseId":4087336807}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-30T07:37:05.988Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-14T14:13:52.253Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"monday dev is out of Beta"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"After finalizing quality improvements and adding additional features and templates, monday dev is now a fully-fledged, robust product for managing all of your software development needs.","changed_at":"2023-04-30T12:34:31.922Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-27","changed_at":"2023-05-02T08:19:49.055Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,159,160]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-04-30T11:53:20.712Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-04-30T11:53:46.221Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-30T11:53:49.032Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"monday dev - Out of Beta.png","assetId":872053588,"isImage":"true","fileType":"ASSET","createdAt":1683811722005,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/4413846808466-Get-started-with-monday-dev","text":"https://support.monday.com/hc/en-us/articles/4413846808466-Get-started-with-monday-dev","changed_at":"2023-04-30T11:55:00.407Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-30T11:55:03.673Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1684068855/Generator_featured%20images/Whats%20new%20page/items%20images/monday_dev_-_Out_of_Beta.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613689/Generator_featured%20images/Whats%20new%20page/New_assets_V2/outofbeta_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Robust email privacy in Email & Activities",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:27:24.437Z","linkedPulseIds":[{"linkedPulseId":3505044503}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-13T08:46:35.663Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved Emails & Activities privacy settings"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Take greater control of your Emails and Activities privacy settings to determine exactly who can see, send, or read emails within your account.","changed_at":"2023-11-07T18:55:00.881Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-24","changed_at":"2023-08-07T12:23:56.145Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-08-07T12:24:19.104Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-08-07T12:24:20.915Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:24:23.281Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019213180#default_sharing","text":"Emails & Activities on monday.com"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691916148/Generator_featured%20images/Whats%20new%20page/items%20images/Robust_email_privacy.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691916148/Generator_featured%20images/Whats%20new%20page/items%20images/Robust_email_privacy.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Export Gantt to PDF",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4014655904}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-21T14:26:53.373Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-24T05:27:03.100Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Export your entire Gantt chart"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Exporting a Gantt chart will now display the entire length and width of it, allowing you to see and retrieve all the information that you need.","changed_at":"2023-04-21T14:29:58.652Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-16","changed_at":"2023-05-01T13:56:20.429Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,159,162]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-04-21T14:31:08.170Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-04-21T14:31:03.954Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-21T14:31:32.104Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image (80).png","assetId":848551677,"isImage":"true","fileType":"ASSET","createdAt":1682313927551,"createdBy":"30507140"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360015643840-The-Gantt-Chart-View-and-Widget#export_your_gantt","text":"https://support.monday.com/hc/en-us/articles/360015643840-The-Gantt-Chart-View-and-Widget#export_your_gantt","changed_at":"2023-04-21T14:32:16.201Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-21T14:32:20.031Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682313855/Generator_featured%20images/Whats%20new%20page/image_80.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: '{"files":[{"name":"export pdf.png","assetId":848824441,"isImage":"true","fileType":"ASSET","createdAt":1682335030642,"createdBy":"14472887"}]}'
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613457/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Export_Gantt_to_PDF_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Ability to remove fields from user profile in admin UI",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4206557482}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-17T23:54:10.647Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-18T00:01:24.834Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Remove fields from user\'s profiles"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"To prevent the display of private data, admins can disable profile fields so that they will not be available for the individual user to view or edit within their account. ","changed_at":"2023-04-24T13:47:05.807Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-13","changed_at":"2023-04-18T00:00:17.449Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,165]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-18T00:01:03.579Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-04-18T00:01:05.498Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-18T00:01:07.128Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-04-15T235028.943.png","assetId":840010014,"isImage":"true","fileType":"ASSET","createdAt":1681617047904,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000278879-How-do-I-edit-my-profile-#remove_profile_fields","text":"https://support.monday.com/hc/en-us/articles/360000278879-How-do-I-edit-my-profile-#remove_profile_fields","changed_at":"2023-04-24T13:20:48.937Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-18T00:01:17.268Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: '{"files":[{"name":"Screenshot 2023-04-18 at 16.56.59.png","assetId":842557223,"isImage":"true","fileType":"ASSET","createdAt":1681826243648,"createdBy":"27849581"},{"name":"Screenshot 2023-04-18 at 16.58.23.png","assetId":842560023,"isImage":"true","fileType":"ASSET","createdAt":1681826311698,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Leaderboard widget",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:29:49.710Z","linkedPulseIds":[{"linkedPulseId":3731294921}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-10T06:59:20.141Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"See your sales team ranked in a leaderboard"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Use the Leaderboard widget to visualize the performance of your sales reps and to understand who is excelling and who may need extra support.","changed_at":"2023-08-10T06:58:56.570Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-03","changed_at":"2023-08-07T12:44:27.851Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[106,4,157]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:44:49.072Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-08-07T12:45:45.057Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:46:40.165Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/10100407939090#","text":"The Leaderboard Widget"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691650455/Generator_featured%20images/Whats%20new%20page/items%20images/leadboard.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691650455/Generator_featured%20images/Whats%20new%20page/items%20images/leadboard.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Account default notification settings",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4089840251}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-14T16:48:03.243Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T13:57:29.287Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Customize default notifications for new users"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Account admins can now customize the default email notification settings that are in place for each new user added to an account.","changed_at":"2023-04-24T13:45:23.279Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-02","changed_at":"2023-04-17T08:56:50.539Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-14T16:50:27.864Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-04-14T16:50:29.956Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-14T16:50:34.530Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 - 2023-04-14T125131.550.png","assetId":839294224,"isImage":"true","fileType":"ASSET","createdAt":1681491106147,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/115005319529#account_default_notifications","text":"https://support.monday.com/hc/en-us/articles/115005319529#account_default_notifications","changed_at":"2023-04-14T16:50:54.777Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-14T16:50:58.190Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: '{"files":[{"name":"Screenshot 2023-04-18 at 16.56.00.png","assetId":842554639,"isImage":"true","fileType":"ASSET","createdAt":1681826175052,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "April roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"test_april"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-04-02","changed_at":"2023-08-23T07:40:20.486Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"ZLaO7SVQfJ4"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "New 'no action' mode for dependencies",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3836247727}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T12:14:20.932Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:13:43.590Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"No action mode for dependencies"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"When customizing dependencies, you can now choose \\"no action mode\\" so that items will not shift automatically on your timeline or Gantt.","changed_at":"2023-04-19T15:17:33.741Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-03-20","changed_at":"2023-04-13T12:20:28.780Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-13T12:24:02.185Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-04-17T11:50:16.971Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-04-13T12:28:07.954Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-13T12:35:39.948Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 - 2023-04-14T122130.849.png","assetId":839243655,"isImage":"true","fileType":"ASSET","createdAt":1681489300780,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360007402599-Dependencies-on-monday-com#Set_up_dependencies","text":"https://support.monday.com/hc/en-us/articles/360007402599-Dependencies-on-monday-com#Set_up_dependencies","changed_at":"2023-04-13T11:59:51.252Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-13T11:58:11.065Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681908952/Generator_featured%20images/Whats%20new%20page/items%20images/New_no_action_mode_for_dependencies.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: '{"files":[{"name":"Screenshot 2023-04-18 at 16.59.08.png","assetId":842561797,"isImage":"true","fileType":"ASSET","createdAt":1681826360394,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-18T16:52:27.500Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685610642/Generator_featured%20images/Whats%20new%20page/New_assets_V2/New_no_action_mode_for_dependencies_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Create doc on item - new permission",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3713862508}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T12:14:20.932Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:37:46.962Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"New permission type: Create doc on item"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"As part of account permissions, we added a new option to allow admins to enable or disable the ability for team members to create workdocs on the item level.","changed_at":"2023-04-24T13:48:59.098Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-03-15","changed_at":"2023-04-13T12:19:26.661Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-13T12:27:54.255Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-04-13T12:28:11.563Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-13T12:35:39.948Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-04-13T12:33:51.580Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-04-14T122013.607.png","assetId":839241311,"isImage":"true","fileType":"ASSET","createdAt":1681489217656,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003457320-Account-permissions","text":"https://support.monday.com/hc/en-us/articles/360003457320-Account-permissions","changed_at":"2023-04-13T11:59:38.155Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-13T11:58:09.868Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681898362/Generator_featured%20images/Whats%20new%20page/items%20images/Notifications_person_filter.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-18T17:01:30.766Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550044/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Notifications_person_filter_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "WorkForms right to left language support",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4168605470}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T12:14:20.932Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:11:15.094Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"WorkForms RTL language support"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"When using WorkForms, we now support RTL (right to left) languages for building and viewing your form!","changed_at":"2023-04-13T12:17:38.662Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-03-13","changed_at":"2023-04-13T12:18:49.249Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-13T12:27:49.957Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-04-13T12:28:17.513Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-13T12:35:39.948Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-04-14T121611.272.png","assetId":839235789,"isImage":"true","fileType":"ASSET","createdAt":1681488975503,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000358700-monday-WorkForms","text":"https://support.monday.com/hc/en-us/articles/360000358700-monday-WorkForms","changed_at":"2023-04-13T11:59:25.401Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-13T11:58:05.324Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681908472/Generator_featured%20images/Whats%20new%20page/items%20images/WorkForms_right_to_left_language_support.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685616909/Generator_featured%20images/Whats%20new%20page/New_assets_V2/workforms_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Ability to hide a file/doc column",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":4065106126}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T12:14:20.932Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:11:14.054Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Ability to hide the File and Doc Column"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"When hiding columns from your board, you can now choose to hide any File or Doc Column within it.","changed_at":"2023-04-13T12:17:24.288Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-03-08","changed_at":"2023-04-13T12:18:27.779Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-04-13T12:27:47.599Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-04-13T12:28:19.388Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-13T12:35:39.948Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-04-14T121418.283.png","assetId":839233072,"isImage":"true","fileType":"ASSET","createdAt":1681488862525,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003384039-Hiding-columns-from-your-board","text":"https://support.monday.com/hc/en-us/articles/360003384039-Hiding-columns-from-your-board","changed_at":"2023-04-13T12:14:12.457Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-13T11:58:03.559Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681910061/Generator_featured%20images/Whats%20new%20page/items%20images/doc_column.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-18T16:52:25.144Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "March roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-18T13:00:14.396Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"","changed_at":"2023-05-30T08:52:17.980Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-03-02","changed_at":"2023-08-23T07:40:24.444Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"s0CV6w00mIU"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "[Performance-scrolling experience] Canvas release",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3892762799}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T12:14:20.932Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:11:13.078Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Performance improvements while scrolling"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve improved our board performance to allow for a much quicker and smoother scrolling experience, without interruptions or delays!\\n","changed_at":"2023-04-13T12:17:41.678Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-03-01","changed_at":"2023-04-13T12:19:10.117Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2023-04-13T12:27:43.201Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-04-13T12:28:20.817Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-13T12:35:39.948Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 - 2023-04-14T121156.151.png","assetId":839229652,"isImage":"true","fileType":"ASSET","createdAt":1681488721936,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-13T11:58:06.855Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-18T16:52:03.781Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "February roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-18T13:00:14.396Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"","changed_at":"2023-05-30T08:52:41.330Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-01","changed_at":"2024-01-31T13:02:16.646Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://youtu.be/uKGaM7fGKGY","text":"monday.com new features | February 2023","changed_at":"2023-05-30T08:52:54.651Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"uKGaM7fGKGY"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "New dashboard creation flow",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3782084747}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T11:24:54.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:47:20.939Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Improved dashboard creation flow"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We revamped the process of building a new dashboard, making it easier than ever to create the reports of your dreams!","changed_at":"2023-03-16T19:44:27.861Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-27","changed_at":"2023-03-16T19:48:36.091Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,161,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T19:50:54.139Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-03-16T19:51:37.110Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-03-16T19:58:07.060Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-16T19:58:14.816Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 152.png","assetId":805118799,"isImage":"true","fileType":"ASSET","createdAt":1678997870446,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360002187819-The-Dashboards","text":"https://support.monday.com/hc/en-us/articles/360002187819-The-Dashboards","changed_at":"2023-03-16T20:05:38.846Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-03-16T20:06:42.002Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681922102/Generator_featured%20images/Whats%20new%20page/items%20images/Improved_dashboard_creation_flow.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Edit custom automation recipes",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3829074913}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T11:24:54.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:47:19.355Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Ability to edit custom automation recipes"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"When editing a custom automation, you now have the option to fully adjust it by adding or removing conditions, triggers, and actions.","changed_at":"2023-03-16T19:44:17.420Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-21","changed_at":"2023-03-16T19:48:31.308Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[164]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-03-16T19:50:51.777Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-03-16T19:51:35.603Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-03-16T19:58:07.060Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-16T19:58:14.816Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 5 (1).png","assetId":805117929,"isImage":"true","fileType":"ASSET","createdAt":1678997833216,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001222900#edit_automation","text":"https://support.monday.com/hc/en-us/articles/360001222900#edit_automation","changed_at":"2023-03-16T20:05:12.455Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-03-16T20:06:40.347Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681910299/Generator_featured%20images/Whats%20new%20page/items%20images/Edit_custom_automation_recipes.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Single-mode view for widgets",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3596093595}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T11:24:54.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:47:18.274Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Dock your widgets for a single-mode view"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We now offer the ability to dock a widget on a board view, dashboard, or item page to make it occupy your screen space more effectively.\\n","changed_at":"2023-03-16T19:44:06.611Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-16","changed_at":"2023-03-16T19:48:28.117Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-03-16T19:50:49.436Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-03-16T19:51:31.085Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-03-16T19:58:07.060Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-16T19:58:14.816Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 41 (1).png","assetId":805113617,"isImage":"true","fileType":"ASSET","createdAt":1678997671414,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001267945#two_types_of_views","text":"https://support.monday.com/hc/en-us/articles/360001267945#two_types_of_views","changed_at":"2023-03-16T20:05:00.217Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-03-16T20:06:38.355Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Copy item columns to subitems",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3597229476}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T11:24:54.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:47:17.182Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Instantly copy item columns to subitems"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now copy the same column types that you have from your parent items to your subitems with the click of a button to help create more alignment in your board!\\n","changed_at":"2023-03-16T19:47:53.225Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-09","changed_at":"2023-03-16T19:48:23.779Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T19:50:40.685Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-03-16T19:51:29.229Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-03-16T19:58:07.060Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-16T19:58:14.816Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-03-16T221251.553.png","assetId":805113103,"isImage":"true","fileType":"ASSET","createdAt":1678997651628,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360011905480#copy_parent_columns","text":"https://support.monday.com/hc/en-us/articles/360011905480#copy_parent_columns","changed_at":"2023-03-16T20:04:46.806Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-03-16T20:06:09.323Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681908627/Generator_featured%20images/Whats%20new%20page/items%20images/Copy_item_columns_to_subitems.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Custom roles for account permissions",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3484724389}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T11:24:54.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:13:46.687Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Custom roles for account permissions"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Enterprise admins can create unique, account-level user roles according to a team member\'s job title, department, or any other suitable definition.\\n","changed_at":"2023-04-18T12:43:35.313Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-06","changed_at":"2023-03-16T19:48:21.183Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-13T12:21:00.797Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T19:50:39.324Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-03-16T19:51:26.915Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-03-16T19:58:07.060Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-03-16T19:58:18.005Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8292728458386-Creating-custom-roles-for-account-permissions","text":"https://support.monday.com/hc/en-us/articles/8292728458386-Creating-custom-roles-for-account-permissions","changed_at":"2023-03-16T20:04:35.301Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T20:05:52.202Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681910356/Generator_featured%20images/Whats%20new%20page/items%20images/Custom_roles_for_account_permissions.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-04-18T17:02:22.243Z"}'
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Notifications person filter",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3516692518}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-13T11:24:54.597Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:37:49.112Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Filter notifications by person"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now filter your bell notifications according to who mentioned you to help you easily locate what you\'re looking for!\\n","changed_at":"2023-03-16T19:43:11.621Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-02-02","changed_at":"2023-03-16T19:48:16.016Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[158,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T19:50:37.714Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-03-16T19:51:25.664Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-03-16T19:58:02.344Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-16T19:58:14.816Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 41.png","assetId":805105432,"isImage":"true","fileType":"ASSET","createdAt":1678997337417,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360015535060#filter_my_notifications","text":"https://support.monday.com/hc/en-us/articles/360015535060#filter_my_notifications","changed_at":"2023-03-16T19:58:36.538Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-03-16T20:05:50.856Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681898362/Generator_featured%20images/Whats%20new%20page/items%20images/Notifications_person_filter.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Jira integration - Full two-way sync",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3717292548}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-18T12:49:20.292Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Jira integration two-way sync"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Using our new Jira integration, it is now easier than ever to create a flow of information that goes in both ways - from Jira to monday.com and back.","changed_at":"2023-04-19T15:19:45.379Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-26","changed_at":"2023-02-09T08:23:25.871Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-09T08:23:36.515Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T10:14:39.937Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-02-16T13:38:21.515Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:33:52.993Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-16T121150.575.png","assetId":769355086,"isImage":"true","fileType":"ASSET","createdAt":1676542330929,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/7238716251538-The-new-Jira-Cloud-integration#two-way-sync","text":"https://support.monday.com/hc/en-us/articles/7238716251538-The-new-Jira-Cloud-integration#two-way-sync","changed_at":"2023-02-09T08:23:34.719Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T09:28:57.327Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681909018/Generator_featured%20images/Whats%20new%20page/items%20images/jira_two_way_sync.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685878154/Generator_featured%20images/Whats%20new%20page/New_assets_V2/jira_integreation_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "New platform font",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3835635004}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T14:13:51.787Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"monday.com now has a new font"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We upgraded our platform font for a more modern and clean look, while offering greater support for international characters and improved readability!","changed_at":"2023-04-18T12:47:30.097Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-19","changed_at":"2023-02-09T08:28:33.589Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T09:02:45.370Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T10:13:41.601Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:07.181Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:33:51.779Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 (85).png","assetId":769356017,"isImage":"true","fileType":"ASSET","createdAt":1676542402160,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-16T09:28:56.044Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681910222/Generator_featured%20images/Whats%20new%20page/items%20images/New_font.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550044/Generator_featured%20images/Whats%20new%20page/New_assets_V2/New_font_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Share email connection in Email & Activities",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:30:20.781Z","linkedPulseIds":[{"linkedPulseId":3505086802}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-08-06T12:40:29.853Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-13T08:48:29.833Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Send emails from a shared account on Emails & Activities"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Using Emails &amp; Activities, your entire team can use one shared, collaborative inbox so that you can keep conversations flowing no matter which team member is at hand.","changed_at":"2023-08-13T08:47:02.960Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-18","changed_at":"2023-08-07T12:27:48.095Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:28:08.559Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-08-07T12:28:10.482Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-08-07T12:28:12.540Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8675571451282-Unique-features-found-only-in-monday-sales-CRM#shared_email_templates","text":"Unique features found only in monday CRM"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691916138/Generator_featured%20images/Whats%20new%20page/items%20images/Share_email.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1691916138/Generator_featured%20images/Whats%20new%20page/items%20images/Share_email.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Doc Column templates",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3590207531}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:53:17.365Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Instantly add a workdoc template"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now create a Doc Column template so that each time a new workdoc is added through the Doc Column it\'ll come ready-made with a pre-prepared outline.","changed_at":"2023-02-09T08:27:09.503Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-05","changed_at":"2023-02-09T08:28:12.673Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T09:30:56.105Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:06.971Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:33:50.447Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 (84).png","assetId":769322650,"isImage":"true","fileType":"ASSET","createdAt":1676540877861,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/9313128951442-The-monday-Doc-Column#doc_template","text":"https://support.monday.com/hc/en-us/articles/9313128951442-The-monday-Doc-Column#doc_template","changed_at":"2023-02-09T08:27:11.731Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-16T09:28:42.377Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681908772/Generator_featured%20images/Whats%20new%20page/items%20images/doc_column.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875236/Generator_featured%20images/Whats%20new%20page/New_assets_V2/New_doc.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Manage users on mobile",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:53:17.365Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"User management settings available on mobile"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Admins can now activate, deactivate, delete, or edit a team member\'s user role right from the mobile app!","changed_at":"2023-02-09T08:31:31.950Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-03","changed_at":"2023-02-09T08:28:18.040Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T09:28:17.347Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-02-16T13:38:07.613Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:33:48.695Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 40 (1).png","assetId":769310069,"isImage":"true","fileType":"ASSET","createdAt":1676540712377,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010952479#manage_team_members","text":"https://support.monday.com/hc/en-us/articles/360010952479#manage_team_members","changed_at":"2023-02-09T08:32:57.689Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-16T09:28:38.544Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "My Work redesign on mobile",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:53:17.365Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Mobile My Work experience revamped"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve redesigned the My Work mobile experience to make it easier than ever to navigate between all your tasks across your account while on the go.","changed_at":"2023-02-16T09:02:25.882Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-02","changed_at":"2023-02-09T08:28:15.478Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161,162]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-16T09:07:54.242Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:07.385Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T09:08:25.748Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-02-16T09:08:36.082Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"My Work redesign on mobile.png","assetId":843813888,"isImage":"true","fileType":"ASSET","createdAt":1681894725073,"createdBy":"27849581"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019159959-Mobile-app-My-Work","text":"https://support.monday.com/hc/en-us/articles/360019159959-Mobile-app-My-Work","changed_at":"2023-02-09T08:30:44.581Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-16T09:16:14.291Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681922294/Generator_featured%20images/Whats%20new%20page/items%20images/My_Work_redesign_on_mobile.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875236/Generator_featured%20images/Whats%20new%20page/New_assets_V2/My_Work_redesign_on_mobile_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "January roundup video",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-04-18T13:00:14.396Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"","changed_at":"2023-05-30T08:52:41.330Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2023-01-01","changed_at":"2024-02-01T12:17:41.800Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: null
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://youtu.be/uKGaM7fGKGY","text":"monday.com new features | February 2023","changed_at":"2023-05-30T08:52:54.651Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: '"s-VuLk0wU6c"'
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Reporting dashboard",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3452007216}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-01-18T14:20:31.861Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:20.250Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Toggle off live data on Dashboards"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"When using a cross-board dashboard, you can now toggle on and off live data to instantly improve its speed and performance."}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-12-25","changed_at":"2023-01-18T15:10:00.027Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,4]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2023-03-19T11:21:53.726Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:06.453Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:34:05.760Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 29.png","assetId":734544324,"isImage":"true","fileType":"ASSET","createdAt":1674054624305,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360002187819-The-Dashboards#Turn_on_or_off_live_data","text":"https://support.monday.com/hc/en-us/articles/360002187819-The-Dashboards#Turn_on_or_off_live_data","changed_at":"2023-01-18T15:10:13.061Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:25.015Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1683189638/Generator_featured%20images/Whats%20new%20page/items%20images/Reporting_dashboard.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875236/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Reporting_dashboard.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Funnel widget",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3504945527}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-01-18T14:20:31.861Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:20.250Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Oversee deal stages with the Funnel Chart"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"On the monday CRM product, we have a new reporting tool which makes it simple to follow the flow of a deal\'s stages from new, all the way to won or lost."}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-12-21","changed_at":"2023-01-18T14:57:16.749Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T12:55:01.761Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,160,4]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T10:35:21.694Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-02-16T13:38:05.734Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:34:04.176Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"funnel widget main.png","assetId":734523598,"isImage":"true","fileType":"ASSET","createdAt":1674053917768,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8805401342482-The-Funnel-Chart","text":"https://support.monday.com/hc/en-us/articles/8805401342482-The-Funnel-Chart","changed_at":"2023-01-18T14:58:34.900Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:39:17.099Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681908834/Generator_featured%20images/Whats%20new%20page/items%20images/Funnel_widget.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685610641/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Funnel_widget_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "New Dependencies Infra and Flow",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3717306909}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-01-18T14:20:31.861Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:20.250Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Enhanced dependencies experience"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We\'ve upgraded our dependencies to work in a much smoother, faster, and intuitive way with no requirement for automations to be set!"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-12-14","changed_at":"2023-01-18T14:27:44.186Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T12:55:10.018Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-16T10:35:19.227Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-16T13:38:29.515Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:34:02.345Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"choose time column.png","assetId":734469449,"isImage":"true","fileType":"ASSET","createdAt":1674052161714,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360007402599","text":"https://support.monday.com/hc/en-us/articles/360007402599","changed_at":"2023-01-18T14:28:02.913Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:39:20.357Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681922933/Generator_featured%20images/Whats%20new%20page/items%20images/New_Dependencies_Infra_and_Flow.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Doc column",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3482500745}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-01-18T14:20:31.861Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:20.250Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"New column type: monday doc"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"We released a new column type called the monday Doc Column, which you can use to create and attach a new workdoc to your board with the click of a button."}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-12-08","changed_at":"2023-01-18T15:00:36.903Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T10:35:17.381Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:06.248Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:34:00.746Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 30.png","assetId":734528113,"isImage":"true","fileType":"ASSET","createdAt":1674054060751,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/9313128951442-The-monday-Doc-Column","text":"https://support.monday.com/hc/en-us/articles/9313128951442-The-monday-Doc-Column","changed_at":"2023-01-18T14:59:26.314Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:23.475Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681922342/Generator_featured%20images/Whats%20new%20page/items%20images/Doc_column1.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875236/Generator_featured%20images/Whats%20new%20page/New_assets_V2/New_doc.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Docs - public link (broadcast)",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3463766712}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-01-17T10:19:18.293Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:20.250Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Share workdocs with external stakeholders"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Easily share a secure, read-only version of your workdocs to people outside of your monday.com account via a shareable link.","changed_at":"2023-02-16T12:50:37.632Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-12-07","icon":null,"changed_at":"2023-01-17T10:26:28.278Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,158,159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T10:35:15.329Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:04.945Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:33:58.718Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Screen Shot 2023-01-17 at 12.29.43.png","assetId":732584791,"isImage":"true","fileType":"ASSET","createdAt":1673951558062,"createdBy":"26519213"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8563692121746-Share-and-export-your-workdocs","text":"https://support.monday.com/hc/en-us/articles/8563692121746-Share-and-export-your-workdocs","changed_at":"2023-01-17T10:24:49.871Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-01-17T10:33:31.004Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681909146/Generator_featured%20images/Whats%20new%20page/items%20images/Docs_-_public_link_broadcast.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685610640/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Docs_-_public_link_broadcast__1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "[iOS] Dashboard view (Widget 360)",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3476241751}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-01-18T14:20:31.861Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:20.250Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"View single-board dashboards on mobile"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Available from versions 4.65 (iOS) and 4.99.0 (Android), you can now access read-only versions of your board and dashboard views!"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-12-01","changed_at":"2023-01-18T14:52:50.969Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[157,162,4,159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-16T10:33:27.292Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-16T13:38:05.418Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-16T10:33:55.946Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 24.png","assetId":734515781,"isImage":"true","fileType":"ASSET","createdAt":1674053653564,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#two_types_of_views","text":"https://support.monday.com/hc/en-us/articles/360001267945-The-board-views#two_types_of_views","changed_at":"2023-01-18T14:53:09.248Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:22.049Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681909388/Generator_featured%20images/Whats%20new%20page/items%20images/iOS_Dashboard_view_Widget_360.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875236/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Dashboard_view_Widget_360.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "Workload widget - Be able to see both items and subitems in the workload widget at the same time",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3449548230}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-07T09:07:30.630Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:43:12.683Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Added customization options on the Workload Widget"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Display data from both your items and subitems simultaneously when using the Workload Widget.","changed_at":"2023-02-07T13:00:46.254Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-11-29","changed_at":"2023-02-07T13:19:26.577Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,160,157]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-21T09:07:42.180Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-21T09:08:09.340Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T09:08:25.364Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 (87).png","assetId":774235253,"isImage":"true","fileType":"ASSET","createdAt":1676975464236,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010699760-The-Workload-View-and-Widget","text":"https://support.monday.com/hc/en-us/articles/360010699760-The-Workload-View-and-Widget","changed_at":"2023-02-07T13:01:14.858Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:37.123Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681910509/Generator_featured%20images/Whats%20new%20page/items%20images/Workload_widget.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875431/Generator_featured%20images/Whats%20new%20page/New_assets_V2/worload.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Docs block store",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3463777232}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-07T09:07:30.630Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:43:12.683Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Workdocs block store"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Easily locate and add any elements (also known as \\"blocks\\") to your workdoc using our new blocks store!","changed_at":"2023-02-07T13:16:48.647Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-11-24","changed_at":"2023-02-07T13:19:22.278Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[158,161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:07:40.407Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-21T09:08:06.896Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T09:08:23.515Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-21T122605.822.png","assetId":774231329,"isImage":"true","fileType":"ASSET","createdAt":1676975173675,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8564146615698-monday-workdoc-text-and-elements","text":"https://support.monday.com/hc/en-us/articles/8564146615698-monday-workdoc-text-and-elements","changed_at":"2023-02-07T13:17:32.337Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:35.698Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681991713/Generator_featured%20images/Whats%20new%20page/items%20images/8.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685610641/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Docs_block_store_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Share email templates",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3505107726}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-07T09:07:30.630Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:43:12.683Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Share templates on Emails and Activities"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"On monday CRM, you can choose whether your email templates will be available only to you, or shared with your account members.","changed_at":"2023-02-07T13:05:35.669Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-11-20","changed_at":"2023-02-07T13:19:16.500Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[158,161,157]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:07:38.172Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-02-21T09:08:04.622Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T09:08:21.967Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 2 (25).png","assetId":774228503,"isImage":"true","fileType":"ASSET","createdAt":1676974977000,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360019213180-Emails-Activities-on-monday-com#share_templates","text":"https://support.monday.com/hc/en-us/articles/360019213180-Emails-Activities-on-monday-com#share_templates","changed_at":"2023-02-07T13:04:43.933Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:34.330Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "CRM Item page",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3504924474}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-07T09:07:30.630Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:43:12.683Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"CRM item page"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"As part monday CRM, you can now view all item card widgets in a large pop-up window, providing you more space to see and update your deals, contacts, accounts, and more.","changed_at":"2023-02-07T13:14:38.789Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-11-15","changed_at":"2023-02-07T13:19:13.417Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:07:36.196Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":6,"post_id":null,"changed_at":"2023-02-21T09:08:01.989Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T09:08:20.657Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"image 1 (86).png","assetId":774227926,"isImage":"true","fileType":"ASSET","createdAt":1676974938400,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/8675571451282-Unique-features-found-only-in-monday-sales-CRM#item_page","text":"https://support.monday.com/hc/en-us/articles/8675571451282-Unique-features-found-only-in-monday-sales-CRM#item_page","changed_at":"2023-02-07T13:12:36.289Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:30.782Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681910131/Generator_featured%20images/Whats%20new%20page/items%20images/CRM_Item_page.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550037/Generator_featured%20images/Whats%20new%20page/New_assets_V2/CRM_Item_page_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Subitem filter - dashboards",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: '{"linkedPulseIds":[{"linkedPulseId":3451994699}]}'
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-07T09:07:30.630Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:43:12.683Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Ability to filter subitems on Dashboards"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now filter the subitems on your Dashboard, allowing you to slice, dice, and drill down more precisely into the information that you need.","changed_at":"2023-02-07T12:55:25.361Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-11-05","changed_at":"2023-02-07T13:19:10.334Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-13T08:58:47.095Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,4]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:07:23.913Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-21T09:07:56.939Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T09:08:18.884Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-21T121900.327.png","assetId":774225197,"isImage":"true","fileType":"ASSET","createdAt":1676974754450,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360002187819-The-Dashboards#filter_subitems_on_dashboard","text":"https://support.monday.com/hc/en-us/articles/360002187819-The-Dashboards#filter_subitems_on_dashboard","changed_at":"2023-02-07T12:56:32.044Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:29.824Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681909329/Generator_featured%20images/Whats%20new%20page/items%20images/Subitem_filter_-_dashboards.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685610644/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Subitem_filter_-_dashboards_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Results summary on WorkForms",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-07T09:07:30.630Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-08-07T12:52:38.104Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Gain insights on your WorkForm results"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"Get an overview of your form results displayed in pie charts, bar graphs, tables, and more using the WorkForm \\"Results\\" tab.","changed_at":"2023-02-07T09:12:39.368Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-11-02","changed_at":"2023-02-07T13:19:06.042Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[162,4]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:07:18.082Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-02-21T09:07:52.873Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T09:08:16.788Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"results or summary.png","assetId":774160341,"isImage":"true","fileType":"ASSET","createdAt":1676970694027,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360000358700#collect_and_analyze_results","text":"https://support.monday.com/hc/en-us/articles/360000358700#collect_and_analyze_results","changed_at":"2023-02-07T09:12:49.876Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-21T09:06:09.298Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681992894/Generator_featured%20images/Whats%20new%20page/items%20images/Chartdoc.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685616909/Generator_featured%20images/Whats%20new%20page/New_assets_V2/workforms_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Audit log improvements",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:42:40.124Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Audit log enhancements"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":" We\'ve improved our Audit Log to cover and display a wider range of events! ","changed_at":"2023-02-09T08:50:37.164Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-10-18","changed_at":"2023-02-09T08:51:16.564Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-09T09:31:29.509Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-03-16T19:28:38.923Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T10:04:36.798Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-02-21T09:56:08.462Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-21T124929.414.png","assetId":774250957,"isImage":"true","fileType":"ASSET","createdAt":1676976577146,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360001259429-The-Audit-Log","text":"https://support.monday.com/hc/en-us/articles/360001259429-The-Audit-Log","changed_at":"2023-02-09T08:50:58.739Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:43.898Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Teams management permissions",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T09:42:38.409Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Team management permissions"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"As part of account permissions, Enterprise admins can now control who can create, manage, edit, and remove teams on an account. ","changed_at":"2023-02-09T08:49:36.362Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-10-12","changed_at":"2023-02-09T08:51:12.762Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T19:28:52.457Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":9,"post_id":null,"changed_at":"2023-03-16T19:28:36.265Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T10:04:35.439Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-02-21T09:55:56.422Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-01T121608.295.png","assetId":774248035,"isImage":"true","fileType":"ASSET","createdAt":1676976367424,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003457320","text":"https://support.monday.com/hc/en-us/articles/360003457320","changed_at":"2023-02-09T08:50:47.844Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:42.188Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1682261342/Generator_featured%20images/Whats%20new%20page/items%20images/Placeholder.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685613003/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Defult_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Burndown chart",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-09T09:23:25.824Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-20T06:42:08.785Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Burndown chart"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"As part of the monday dev product, we created a brand new burndown chart to help seamlessly monitor all aspects of your sprint\'s progression!","changed_at":"2023-02-09T08:49:06.064Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-10-10","changed_at":"2023-02-09T08:49:10.208Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-03-13T08:58:45.101Z"}'
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[2]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[160,106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-09T09:30:04.152Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-02-16T13:38:07.824Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-09T09:34:02.297Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-21T125856.952.png","assetId":774259032,"isImage":"true","fileType":"ASSET","createdAt":1676977149023,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360010646539#burndown_chart","text":"https://support.monday.com/hc/en-us/articles/360010646539#burndown_chart","changed_at":"2023-02-09T08:49:21.468Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-02-09T09:34:49.450Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: '{"files":[{"name":"Burndown chart","fileId":"d81c7df6-cfee-822e-124f-a00b29c883e8","isImage":"false","fileType":"MONDAY_DOC","objectId":4203993812,"createdAt":1679840590271,"createdBy":"30507140","linkToFile":"https://monday.monday.com/docs/4203993812"}]}'
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681975663/Generator_featured%20images/Whats%20new%20page/items%20images/5.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685550037/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Burndown_chart_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "Filter board subitems",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: '{"changed_at":"2023-02-14T14:01:49.912Z","personsAndTeams":[{"id":9703051,"kind":"person"}]}'
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-05-01T13:57:45.172Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"Ability to filter board subitems"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"You can now use the advanced board filter to drill down into specific subitems on your board and view the exact information that you need.","changed_at":"2023-02-09T08:47:33.157Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: '{"date":"2022-10-03","changed_at":"2023-02-09T08:47:44.917Z"}'
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4,157]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-03-16T19:28:54.789Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-03-16T19:28:29.821Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-02-21T10:04:34.160Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: '{"files":[{"name":"Group 1 - 2023-02-21T124132.174.png","assetId":774243779,"isImage":"true","fileType":"ASSET","createdAt":1676976100166,"createdBy":"9703051"}]}'
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: '{"url":"https://support.monday.com/hc/en-us/articles/360003624660-The-Board-Filters#Filter_your_subitems","text":"https://support.monday.com/hc/en-us/articles/360003624660-The-Board-Filters#Filter_your_subitems","changed_at":"2023-02-09T08:47:40.764Z"}'
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-21T09:39:39.865Z"}'
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1681922846/Generator_featured%20images/Whats%20new%20page/items%20images/2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1685875681/Generator_featured%20images/Whats%20new%20page/New_assets_V2/Filter_board_subitems_1.png"'
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: '{"ids":[2]}'
                                }
                            ]
                        },
                        {
                            name: "improve communications",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-05-02T08:10:11.399Z"}'
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"example6"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"example6","changed_at":"2023-02-26T08:53:36.234Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[5]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[158]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-26T08:21:28.250Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2023-02-27T21:07:34.136Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-02-27T21:00:50.717Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-27T21:13:38.257Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1677488524/Generator_featured%20images/Whats%20new%20page/whats_new_image_example_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "increase efficiency",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"example7"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"example7","changed_at":"2023-02-26T08:53:46.018Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[1]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[161]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-26T08:21:30.192Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2023-02-27T21:07:35.637Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-02-27T21:00:52.133Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":4,"post_id":null,"changed_at":"2023-02-27T21:13:39.565Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1677488524/Generator_featured%20images/Whats%20new%20page/whats_new_image_example_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "web browser",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"example8"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"example8","changed_at":"2023-02-26T08:53:53.650Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[7]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[106]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":3,"post_id":null,"changed_at":"2023-02-26T08:53:14.408Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2023-02-27T21:07:37.120Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-02-27T21:00:53.702Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-27T21:10:56.440Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1677488524/Generator_featured%20images/Whats%20new%20page/whats_new_image_example_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "desktop app",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"example9"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"example9","changed_at":"2023-02-26T08:53:59.066Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: '{"ids":[6]}'
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[4]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":2,"post_id":null,"changed_at":"2023-02-26T08:53:15.888Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":0,"post_id":null,"changed_at":"2023-02-27T21:07:38.753Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":7,"post_id":null,"changed_at":"2023-02-27T21:00:55.393Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-02-27T21:10:58.232Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1677488524/Generator_featured%20images/Whats%20new%20page/whats_new_image_example_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "tablet",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: null
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: null
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1677488524/Generator_featured%20images/Whats%20new%20page/whats_new_image_example_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "mobile",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"share insights"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"share insights","changed_at":"2023-03-19T14:26:33.164Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[159]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: null
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: null
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: null
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: null
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: '"https://dapulse-res.cloudinary.com/image/upload/v1677488524/Generator_featured%20images/Whats%20new%20page/whats_new_image_example_2.png"'
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        },
                        {
                            name: "new ai capabilities",
                            column_values: [
                                {
                                    id: "subitems",
                                    column: {
                                        title: "Subitems"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "board_relation8",
                                    column: {
                                        title: "Release Board"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "lookup1",
                                    column: {
                                        title: "Mirror"
                                    },
                                    value: null
                                },
                                {
                                    id: "dup__of_mirror",
                                    column: {
                                        title: "Product POC"
                                    },
                                    value: null
                                },
                                {
                                    id: "person",
                                    column: {
                                        title: "Writer"
                                    },
                                    value: null
                                },
                                {
                                    id: "people",
                                    column: {
                                        title: "Designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "color95",
                                    column: {
                                        title: "Ready_to_post"
                                    },
                                    value: null
                                },
                                {
                                    id: "text",
                                    column: {
                                        title: "title"
                                    },
                                    value: '"blah blah blah"'
                                },
                                {
                                    id: "short_text",
                                    column: {
                                        title: "Short_text"
                                    },
                                    value: '{"text":"more blah blah blah ","changed_at":"2023-04-16T09:06:00.056Z"}'
                                },
                                {
                                    id: "date4",
                                    column: {
                                        title: "Date"
                                    },
                                    value: null
                                },
                                {
                                    id: "color0",
                                    column: {
                                        title: "Release_highlights"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown",
                                    column: {
                                        title: "Products"
                                    },
                                    value: null
                                },
                                {
                                    id: "dropdown08",
                                    column: {
                                        title: "Benefit"
                                    },
                                    value: '{"ids":[163,162]}'
                                },
                                {
                                    id: "color2",
                                    column: {
                                        title: "Release_type"
                                    },
                                    value: '{"index":105,"post_id":null,"changed_at":"2023-04-16T09:06:35.250Z"}'
                                },
                                {
                                    id: "team",
                                    column: {
                                        title: "Team"
                                    },
                                    value: '{"index":8,"post_id":null,"changed_at":"2023-04-16T09:06:37.917Z"}'
                                },
                                {
                                    id: "color1",
                                    column: {
                                        title: "Release_status"
                                    },
                                    value: '{"index":1,"post_id":null,"changed_at":"2023-04-16T09:08:08.382Z"}'
                                },
                                {
                                    id: "color4",
                                    column: {
                                        title: "Plan"
                                    },
                                    value: '{"index":5,"post_id":null,"changed_at":"2023-04-16T09:02:08.713Z"}'
                                },
                                {
                                    id: "file",
                                    column: {
                                        title: "Main image"
                                    },
                                    value: null
                                },
                                {
                                    id: "link",
                                    column: {
                                        title: "Article_link"
                                    },
                                    value: null
                                },
                                {
                                    id: "color00",
                                    column: {
                                        title: "Inner page"
                                    },
                                    value: null
                                },
                                {
                                    id: "mirror_1",
                                    column: {
                                        title: "Mirror 1"
                                    },
                                    value: null
                                },
                                {
                                    id: "formula",
                                    column: {
                                        title: "Formula"
                                    },
                                    value: null
                                },
                                {
                                    id: "monday_doc",
                                    column: {
                                        title: "Inner page content"
                                    },
                                    value: null
                                },
                                {
                                    id: "text9",
                                    column: {
                                        title: "Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "files",
                                    column: {
                                        title: "asset for designer"
                                    },
                                    value: null
                                },
                                {
                                    id: "label",
                                    column: {
                                        title: "need image"
                                    },
                                    value: null
                                },
                                {
                                    id: "text85",
                                    column: {
                                        title: "Monthly_video_id"
                                    },
                                    value: null
                                },
                                {
                                    id: "text1",
                                    column: {
                                        title: "Desktop_Cloudinary_image_url"
                                    },
                                    value: null
                                },
                                {
                                    id: "connect_boards",
                                    column: {
                                        title: "Connect boards"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "connect_boards_1",
                                    column: {
                                        title: "Connect boards 1"
                                    },
                                    value: "{}"
                                },
                                {
                                    id: "dropdown1",
                                    column: {
                                        title: "Location"
                                    },
                                    value: null
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    }
};
